import { inject, Injectable } from '@angular/core';
import { triggerFn, WIDGET_CONSTANTS, StudioUtils, extractType, isDuplicateName, initCaps, isNumberType, getClonedObject, isUndefined, findValueOf, getNewEventsObject } from '@wms/core';
import {
  includes,
  forEach,
  each,
  keys,
  union,
  cloneDeep,
  find,
  get,
  intersection,
  isEmpty,
  remove,
  isNull,
  difference,
  isFunction,
  isNil,
  map,
  clone,
  reject,
  isEqual
} from 'lodash-es'
import { WmHttpService, TypeFactoryService, WebserviceService, ProjectService, PageService, DialogService } from '@wms/services';
import { Injector } from '@angular/core';
import { getValidJSON, isDefined, replace, runtimeEventManager, isObject } from '@wm/core';
import { BaseComponent, IWMSStandaloneEditorConstructionOptions } from '@wms/components';
import { VARIABLE_CONSTANTS, getServiceTypesByCollectionType, ServiceTypeGroup, getVariableConfig, BaseVariablePropertyFactoryService, WmsWebsocketVariableService, WmsLiveVariable, WmsCrudVariable, WmsServiceVariable, WmsModelVariable, WmsLogoutVariableService, WmsNotificationVariableService, WmsNavigationVariableService, WmsDeviceVariableService } from '@wms/variables';
import { stringStartsWith } from '@wm/core';
import { Subject } from 'rxjs';
import { environment } from "@wms/app";
import {AppResourceManagerService, ComponentType} from "@wms/design-container";

export let AppInjector: Injector;

@Injectable({
  providedIn: 'root'
})
export class BaseVariableService extends BaseComponent {

  TARGET = 'VariableService';
  API_META: any = {
    addAppVariables: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/variables",
      method: 'POST'
    },
    addPageVariables: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/pages/:pageName/variables",
      method: 'POST'
    },
    getAppVariables: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/variables",
      method: 'GET'
    },
    getPageVariables: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/pages/:pageName/variables",
      method: 'GET'
    },
    updateAppVariables: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/variables",
      method: 'PUT'
    },
    updatePageVariables: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/pages/:pageName/variables",
      method: 'PUT'
    },
    deleteAppVariables: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/variables?variableNames=:deletedNames",
      method: 'DELETE'
    },
    deletePageVariables: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/pages/:pageName/variables?variableNames=:deletedNames",
      method: 'DELETE'
    },
    moveAppVariables: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/variables/move?pageName=:toPage",
      method: 'POST'
    },
    movePageVariables: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/pages/:pageName/variables/move",
      method: 'POST'
    },
    getServiceOpInfo: {
      url: environment.SERVICES_BASE_PATH + "services/servicedefs",
      method: 'GET'
    },
    getPrefabServiceOpInfo: {
      url: environment.SERVICES_BASE_PATH + "services/prefabs/:prefabName/servicedefs",
      method: 'GET'
    }
  };
  selectedVariableObj: any;
  PROPERTY_PREFIX = 'wm_input_';
  variableCollection: any = {};
  selectedVariable: any;
  runMode: boolean; // TO DO
  MAIN_PAGE = 'Main';
  variablesForSave: any = [];
  unsavedVariable: any;
  projectId: any;
  /*Initializing a map to store all changes made to variables*/
  CRUDMAP: any = {
    CREATE: {},
    UPDATE: {},
    DELETE: {},
    MOVE: {}
  };
  metadataMap: Map<string, any> = new Map();
  propertyGroups: any;
  reloadRequired: any = [];
  variableNameIterator: any = {};
  variableCategoryToNameMap: any = {};
  isVariableEventChanged: boolean = false;
  studioCopy: any = {};
  pageScopeMap: any = {};
  isRunMode = false; // TODO
  baseVariablePropertyFactory: any;
  variableInstanceCollection: any = {};
  bindingsToClear: any = [];
  jsonEditorViewOption: any = 1;
  liveVariableService: any;
  crudVariableService: any;
  serviceVariableService: any;
  webSocketVariableService: any;
  prevSelectedVariable: any;
  selectedEvt: any;
  modelVariableService: any;
  disableDialogActions: any;
  DOT_EXPR_REX = /^\[("|')[\w\W]*(\1)\]$/;
  reloadVariablesSubject: any = new Subject();
  createOnly: any = false;
  pageService: PageService;
  variableDialogMsg: any;
  currentVariableView: string;
  dialogHeaderKey: string;
  dialogHeaderIcon: string;
  newBtnCaption: string;
  serviceTypeGroups: any;
  serviceTypes: any;
  selectedVariableView: any;
  isVariableDialog: boolean = false;
  variableServiceMapper: any = {
    'wm.CrudVariable': 'crudVariableService',
    'wm.LiveVariable': 'liveVariableService',
    'wm.ServiceVariable': 'serviceVariableService',
    'wm.Variable': 'modelVariableService',
    'wm.LoginVariable': 'modelVariableService',
    'wm.TimerVariable': 'modelVariableService'
  };
  tabOrder: string[] = ['list', 'create', 'update', 'delete'];

  jsonTextEditor: IWMSStandaloneEditorConstructionOptions = {
    value: '{"value": ""}',
    language: "json"
  };

  onDateChangeSubject: any = new Subject();
  onEventOptionsChangeSubject: any = new Subject();
  updateEventOptionsSubject: any = new Subject();

  jsEventsInfo: any = [];
  skipSelectingCurrentTab: boolean = false;

  constructor(private injector: Injector, private typeFactory: TypeFactoryService, private wmHttpService: WmHttpService,
    private webService: WebserviceService, private dialogService: DialogService,
              private resourceMngr: AppResourceManagerService, private _baseVariablePropertyFactory: BaseVariablePropertyFactoryService) {
    super();
    AppInjector = this.injector;
    this.wmHttpService.registerApiMeta(this.TARGET, this.API_META);
    this.projectId = this.projectService.getProjectId();
    this.pageService = inject(PageService);
    this.baseVariablePropertyFactory = _baseVariablePropertyFactory;
    runtimeEventManager.setService('variableService', this);
    let localeCodesMap: any = [];
    import('src/assets/resources/files/localeCodesMap').then(response => {
      localeCodesMap = response.localeCodesMap;
    });
    this.registerDestroyListener.add(this.eventManager.updateSupportedVarObservable().subscribe((supportedLocale: any) => {
        this.updateSupportedLocaleVar(supportedLocale,localeCodesMap);
    }));
    this.registerDestroyListener.add(this.eventManager.reloadAppVariablesAsObservable().subscribe(()=>{
      this.reloadAppVariables();
    }))
  }

  onEventOptionsChangeObs() {
    return this.onEventOptionsChangeSubject.asObservable();
  }

  updateEventsObs() {
    return this.updateEventOptionsSubject.asObservable();
  }

  reloadVariablesObs() {
    return this.reloadVariablesSubject.asObservable();
  }

  onDateChangeObs() {
    return this.onDateChangeSubject.asObservable();
  }

  getVariableConstants () {
    return VARIABLE_CONSTANTS;
  }

  // wms:update-and-save-supportedLocale-variable
  updateSupportedLocaleVar(supportedLocale: any,localeCodesMap: any) {
    let supportedLocaleVar = this.getVariableByName('supportedLocale'),
      supportedLocaleCodesMap: any = {};

    // validateBindings();
    if (supportedLocaleVar) {
      forEach(supportedLocale, (locale: any) => {
        supportedLocaleCodesMap[locale] = localeCodesMap[locale];
      });
      /*Do not engage saving the variable if the dataset already has same values*/
      if (isEqual(supportedLocaleCodesMap, supportedLocaleVar.dataSet)) {
        return;
      }
      supportedLocaleVar.dataSet = supportedLocaleCodesMap;
      // Updating variable with new values using Variable service
      this.updateVariable(supportedLocaleVar.name, supportedLocaleVar);
      // in case of prefabs, update the page variables, else update the application variables
      if (this.projectService.isPrefabType()) {
        this.saveVariables('Main');
      } else {
        this.saveAppVariables();
      }
      this.i18nService.setAppSupportedLocale(supportedLocale);
    }
  }

  /* function to set page variables for a specified page*/
  setPageVariables(pageName: string, pageVariables: any, componentType?: any) {
    if (isEmpty(this.i18nService.localeBundle)) {
      this.i18nService.getLocaleBundle();
    }
    if (componentType === ComponentType.PREFAB &&  this.projectService.isApplicationType()) {
      pageName = VARIABLE_CONSTANTS.PREFAB_PREFIX + pageName;
    }
    /* check for existence */
    this.variableCollection = this.variableCollection || {};
    /* set the variables*/
    this.variableCollection[pageName] = pageVariables || {};

    this.register(pageName, this.variableCollection[pageName], true);

    // TO DO
    // expose partial page's Variabes to its container's scope (to be visible to parent)
    // if (containerScope) {
    //   containerScope.Variables = $s.Variables;
    //   containerScope.Actions = $s.Actions;
    // }

    // // if specified, call page variables ready function in the page.js
    // if (!appVariableReadyFired) {
    //   Utils.triggerFn($rs.onAppVariablesReady, $rs.Variables);
    //   appVariableReadyFired = true;
    // }

    // Utils.triggerFn($s.onPageVariablesReady);
  }

  /*Function to initialize category-to-name map*/
  initVariableNameMap() {
    const variableConfig = getVariableConfig();
    forEach(variableConfig, (variable) => {
      this.variableCategoryToNameMap[variable.category] = variable.defaultName;
    });
  }


  /*Function to set the variable name iterator with the specified value*/
  resetVariableNameIterator() {
    this.variableNameIterator = {};
    Object.keys(this.variableCategoryToNameMap).forEach((category) => {
      this.variableNameIterator[category] = 1;
    });
  }

  getSelectedVariableInstance() {
    if(this.selectedVariable.variableObject) {
      const collection = this.variableInstanceCollection[this.selectedVariable.variableObject.owner === 'App' ? 'App' : this.pageService.activePageName];
      return collection[this.selectedVariable.variableObject.name] ? collection[this.selectedVariable.variableObject.name] : collection[this.selectedVariable.variableObject._oldName];
    }
  }

  /* function to initialize header key based on current collection type */
  initHeaderOptions(variableView: any) {
    let title = "LABEL_VARIABLES",
      newBtnCaption = 'LABEL_NEW_VARIABLE';
    switch (variableView) {
      case "Actions":
        title = "LABEL_ACTIONS";
        newBtnCaption = 'LABEL_NEW_ACTION';
        if (this.createOnly) {
          title = 'LABEL_NEW_ACTION';
        }
        break;
      default:
        title = "LABEL_VARIABLES";
        newBtnCaption = 'LABEL_NEW_VARIABLE';
        if (this.createOnly) {
          title = 'LABEL_NEW_VARIABLE';
        }
    }
    this.dialogHeaderKey = title;
    this.newBtnCaption = newBtnCaption;
  }

  /**
   * Common function used to prepare dynamic binding objects for a variable
   * takes a list of property objects and creates corresponding binding objects for each property,
   * if a binding exists, takes the value from existing binding and assigns it to new binding object
   * These binding objects are the target for storing binding info of input params for a variable
   * Example of binding objects created
   *  [
   {
     "target": "a",
      "value": "bind:someproperty"
    },
    {
      "target": "b",
      "value": "bind:someproperty"
    }
    ]
    * @param properties list of property objects
    */
  prepareBindings(properties: any, bindingTarget?: any) {
    /* sanity check */
    if (!properties) {
      return;
    }
    bindingTarget = bindingTarget || 'dataBinding';

    let selectedVariable = this.selectedVariable,
      bindings: any = [],
      existingBindings = selectedVariable.variableObject[bindingTarget],
      existingBinding,
      bindingObj,
      isMigrationRequired = selectedVariable.category === "wm.NavigationVariable" || selectedVariable.category === "wm.DeviceVariable";
    properties.forEach((property: any) => {
      bindingObj = bindings[bindings.push({...property}) - 1];
      existingBinding = find(existingBindings, function (obj) {
        return property.target === obj.target;
      });
      if (existingBinding) {
        bindingObj.value = existingBinding.value;
      } else if (isMigrationRequired && isDefined(selectedVariable.variableObject[property.target])) {
        /* handling migration for old projects created pre-dataBinding migration changes */
        bindingObj.value = selectedVariable.variableObject[property.target];
      }
    });
    selectedVariable.variableObject[bindingTarget] = bindings;
  }

  createServiceInstance(owner: any, name: any, category: any, variable?: any) {
    if (!this.variableInstanceCollection[owner]) {
      return;
    }
    const variableInfo = variable || this.selectedVariableObj || this.selectedVariable;
    variableInfo._skipInitiateCallback = true;
    if (category === 'wm.LiveVariable') {
      //CHECK: if page owner is not present, error is thrown
      this.variableInstanceCollection[owner][name] = new WmsLiveVariable(variableInfo, this.injector);
      this.variableInstanceCollection[owner][name]['httpService'] = this.wmHttpService;
    } else if (category === 'wm.CrudVariable') {
      this.variableInstanceCollection[owner][name] = new WmsCrudVariable(variableInfo, this.injector);
    } else if (category === 'wm.ServiceVariable') {
      this.variableInstanceCollection[owner][name] = new WmsServiceVariable(variableInfo, this.injector);
    } else if (category === 'wm.Variable' || category === 'wm.LoginVariable' || category === 'wm.TimerVariable') {
      this.variableInstanceCollection[owner][name] = new WmsModelVariable(variableInfo, this.injector);
    } else if (category === 'wm.WebSocketVariable') {
      this.variableInstanceCollection[owner][name] = this.injector.get(WmsWebsocketVariableService);
    } else if (category === 'wm.LogoutVariable') {
      this.variableInstanceCollection[owner][name] = this.injector.get(WmsLogoutVariableService);
    } else if (category === 'wm.NavigationVariable') {
      this.variableInstanceCollection[owner][name] = this.injector.get(WmsNavigationVariableService);
    } else if (category === 'wm.NotificationVariable') {
      this.variableInstanceCollection[owner][name] = this.injector.get(WmsNotificationVariableService);
    } else if (category === 'wm.DeviceVariable') {
      this.variableInstanceCollection[owner][name] = this.injector.get(WmsDeviceVariableService);
    }
  }

  // registers a variable collection in the specified namespace
  register(nameSpace: string, variables: any, loadValuesInStudio: boolean, scope?: any) {
    // extend the variables with properties from basefactory
    variables = this.extendVariables(variables);
    if (!this.variableInstanceCollection[nameSpace]) {
      this.variableInstanceCollection[nameSpace] = {};
    }
    forEach(Object.keys(variables), (item) => {
      this.selectedVariableObj = variables[item];
      this.createServiceInstance(nameSpace, item, variables[item].category);
    });
    this.selectedVariableObj = undefined;

    // store the variables in provided namespace
    // pageScopeMap[nameSpace] = scope; - TO DO
    this.variableCollection = this.variableCollection || {};
    this.variableCollection[nameSpace] = variables;

    // update the variable values in RUN mode
    if (loadValuesInStudio || this.runMode) { // -- TO DO?
      this.updateContextVariables(nameSpace);
      // emit an event to specify variables are loaded -- TO DO?
      // $rootScope.$emit('on-' + nameSpace + '-variables-ready', variables);
    }
    forEach(Object.keys(this.variableCollection), (item) => {
      const collection = this.variableCollection[item];
      forEach(collection, (obj: any) => {
        if (this.variableInstanceCollection[item][obj.name] && this.variableInstanceCollection[item][obj.name].invoke) {
          obj.invoke = this.variableInstanceCollection[item][obj.name].invoke;
        }
      });
    });
  }

  /* unloads the variables from the specified namespace */
  unload(namespace: string) {
    /* sanity check */
    if (!namespace) {
      return;
    }
    this.variableCollection = this.variableCollection || {};

    /*
     * loop through each variable in the namespace and remove the watchers if any
     */
    // TODO: check if this is required
    // if (watchers[scopeId]) {
    //   WM.forEach(self.variableCollection[namespace], function (variable, name) {
    //     if (watchers[scopeId][name]) {
    //       watchers[scopeId][name].forEach(Utils.triggerFn);
    //     }

    //     // remove bound map nodes
    //     _.set(internalBoundNodeMap, scopeId, undefined);
    //   });
    // }

    /* remove the variables in namespace from the variable collection*/
    delete this.variableCollection[namespace];
    delete this.variableInstanceCollection[namespace];
    if (!this.runMode) {
      delete this.studioCopy[namespace];
    }

    // remove the destroyed scope references from map, to be garbage collected
    // TODO: check if this is required
    // _.forEach(pageScopeMap, function (v, k) {
    //   if (v.$$destroyed) {
    //     delete pageScopeMap[k];
    //   }
    // });
  }

  /*
    * Updates the variables in a context with their latest values
    * context refers to the namespace for the variables collection, like 'app'/page/partial/prefab
    */
  updateContextVariables(context: any, scope?: any) { // TO DO - should add scope?
    this.studioCopy[context] = {};

    // scope = scope || pageScopeMap[context] || {};
    // watchers[scope.$id] = {};

    /* Maintain a copy of the variables in the exposed collection
     * Primary reason for this:
     * StudioMode: any update to the dataSet or other properties by variable will not reflect in the actual collection
     * RunMode: The same collection is used by same partials/prefabs appearing twice in a page */

    //-- TO DO - needed?
    // this.variableCollection[scope.$id] = cloneDeep(this.variableCollection[context]);

    // scope.Variables = this.variableCollection[scope.$id];

    /* extend scope variables with app variables, in studio mode */
    if (context !== 'App') { // TO DO
      // WM.forEach(self.variableCollection[$rootScope.$id], function (variable, name) {
      //   if (!scope.Variables.hasOwnProperty(name)) {
      //     Object.defineProperty(scope.Variables, name, {
      //       configurable: true,
      //       get: function () {
      //         return variable;
      //       }
      //     });
      //   }
      // });
    }
    forEach(this.variableCollection[context], ((variable, name) => {
      // TO DO - needed?
      /*Define Property getter setter for operation Info*/
      // Object.defineProperty(variable, '_wmServiceOperationInfo', {
      //   get: function () {
      //     return MetaDataFactory.getByOperationId(variable.operationId, variable._prefabName);
      //   },
      //   configurable: true
      // });
      //Trigger update on variable based on run/studio mode
      this.updateVariableData(variable, name, context, scope, { skipFetchData: true });
    }));

    // Expose the Actions in a separate namespace (Post 9.0) -- TO DO?
    // defineActionsOnScope(scope, context);
  }

  /**
   * Returns the object node for a bind object, where the value has to be updated
   * obj.target = "a"
   * @param obj
   * @param root
   * @param variable
   * @returns {*}
   */
  getTargetObj(obj: any, root: any, variable: any) {
    /*
     * if the target key is in the form as "['my.param']"
     * keep the target key as "my.param" and do not split further
     * this is done, so that, the computed value against this binding is assigned as
     *      {"my.param": "value"}
     * and not as
     *      {
     *          "my": {
     *              "param": "value"
     *          }
     *      }
     */
    let target = obj.target,
      targetObj,
      rootNode = variable[root];
    if (this.DOT_EXPR_REX.test(target)) {
      targetObj = rootNode;
    } else {
      target = target.substr(0, target.lastIndexOf('.'));
      if (obj.target === root) {
        targetObj = variable;
      } else if (target) {
        targetObj = findValueOf(rootNode, target, true);
      } else {
        targetObj = rootNode;
      }
    }
    return targetObj;
  }

  /**
   * Gets the key for the target object
   * the computed value will be updated against this key in the targetObject(computed by getTargetObj())
   * @param target
   * @param regex
   * @returns {*}
   */
  getTargetNodeKey(target: any) {
    /*
     * if the target key is in the form as "['my.param']"
     * keep the target key as "my.param" and do not split further
     * this is done, so that, the computed value against this binding is assigned as
     *      {"my.param": "value"}
     * and not as
     *      {
     *          "my": {
     *              "param": "value"
     *          }
     *      }
     */
    let targetNodeKey;
    if (this.DOT_EXPR_REX.test(target)) {
      targetNodeKey = target.replace(/^(\[["'])|(["']\])$/g, '');
    } else {
      targetNodeKey = target.split(".").pop();
    }
    return targetNodeKey;
  }

  /**
   * New Implementation (DataBinding Flat Structure with x-path targets)
   * processes a dataBinding object, if bound to expression, watches over it, else assigns value to the expression
   * @param obj dataBinding object
   * @param scope scope of the variable
   * @param root root node string (dataBinding for all variables, dataSet for static variable)
   * @param variable variable object
   */
  processBindObject(obj: any, scope: any, root: any, variable: any) {
    let target = obj.target,
      targetObj = this.getTargetObj(obj, root, variable),
      targetNodeKey = this.getTargetNodeKey(target);

    if (stringStartsWith(obj.value, "bind:")) {
      // TODO
      // BindingManager.register(scope, obj.value.replace("bind:", ""), function (newVal, oldVal) {
      //   if ((newVal === oldVal && WM.isUndefined(newVal)) || (WM.isUndefined(newVal) && (!WM.isUndefined(oldVal) || !WM.isUndefined(targetObj[targetNodeKey])))) {
      //     return;
      //   }
      //   // When a variable is bound to an empty object then its datset shouldn't be empty, if empty
      //   // then the bind dialog won't contain datset values for that particular variable.
      //   // Hence, check if the bound value is an empty object, then retain the old dataset, if defined.
      //   if (!runMode && WM.isDefined(oldVal) && _.isEqual(newVal, {})) {
      //     return;
      //   }
      //   //Skip cloning for blob column
      //   if (!_.includes(['blob', 'file'], obj.type)) {
      //     newVal = Utils.getClonedObject(newVal);
      //   }
      //   setValueToNode(target, obj, root, variable, newVal); // cloning newVal to keep the source clean

      //   if (runMode) {
      //     /*set the internal bound node map with the latest updated value*/
      //     _.set(internalBoundNodeMap, [variable.activeScope.$id, variable.name, root, target], newVal);
      //     /*update the internal nodes after internal node map is set*/
      //     if (WM.isObject(newVal)) {
      //       updateInternalNodes(target, root, variable);
      //     }
      //   }
      // }, { 'deepWatch': true });
    } else if (isDefined(obj.value)) {
      this.setValueToNode(target, obj, root, variable, obj.value, true);
      // TODO - needed?
      // if (runMode && root !== targetNodeKey) {
      //   _.set(internalBoundNodeMap, [variable.activeScope.$id, variable.name, root, target], obj.value);
      // }
    }
  }

  //debouncing callVariableMethod
  _invoke(variable: any, op: any) {
    // TODO - needed?
    // let cancelFn = noop, debouncedFn, key = variable._id + '__' + op + '__' + (_.get(variable, ['activeScope', '$id']) || '');
    // if (timers[key]) {
    //     cancelFn = timers[key].cancel;
    // }
    // cancelFn();
    // debouncedFn = _.debounce(function () {
    //     variable[op]();
    // }, 100);
    // timers[key] = debouncedFn;
    // debouncedFn();
  }

  processVariablePostBindUpdate(nodeName: any, nodeVal: any, nodeType: any, variable: any, noUpdate: any) {
    if (variable.category === 'wm.LiveVariable') {
      if (variable.operation === 'read') {
        if (nodeName === 'dataBinding') {
          forEach(nodeVal, (val, key) => {
            variable.filterFields[key] = {
              'value': val
            };
          });
        } else {
          variable.filterFields[nodeName] = {
            'value': nodeVal,
            'type': nodeType
          };
        }
        /* if auto-update set for the variable with read operation only, get its data */
        if (variable.autoUpdate && !isUndefined(nodeVal) && isFunction(variable.update) && !noUpdate) {
          this._invoke(variable, 'update');
        }
      } else {
        if (nodeName === 'dataBinding') {
          variable.inputFields = nodeVal;
        } else {
          variable.inputFields[nodeName] = nodeVal;
        }
        /* if auto-update set for the variable with read operation only, get its data */
        if (variable.autoUpdate && !isUndefined(nodeVal) && isFunction(variable[variable.operation + 'Record']) && !noUpdate) {
          this._invoke(variable, variable.operation + 'Record');
        }
      }
    } else if (variable.category === 'wm.ServiceVariable' || variable.category === 'wm.CrudVariable') {
      if (variable.autoUpdate && !isUndefined(nodeVal) && isFunction(variable.update) && !noUpdate) {
        this._invoke(variable, 'update');
      }
    } else if (variable.category === 'wm.LoginVariable') {
      if (variable.autoUpdate && !isUndefined(nodeVal) && isFunction(variable.login) && !noUpdate) {
        this._invoke(variable, 'login');
      }
    } else if (variable.category === 'wm.DeviceVariable') {
      variable[nodeName] = nodeVal;
      if (variable.autoUpdate && !isUndefined(nodeVal) && isFunction(variable.invoke) && !noUpdate) {
        this._invoke(variable, 'invoke');
      }
    }
  }

  setValueToNode(target: any, obj: any, root: any, variable: any, value: any, noUpdate: any) {
    let targetNodeKey = this.getTargetNodeKey(target),
      targetObj = this.getTargetObj(obj, root, variable);
    value = isDefined(value) ? value : obj.value;
    /* sanity check, user can bind parent nodes to non-object values, so child node bindings may fail */
    if (targetObj) {
      targetObj[targetNodeKey] = value;
    }
    this.processVariablePostBindUpdate(targetNodeKey, value, obj.type, variable, noUpdate);
  }

  /* function to update binding of a field of a variable */
  bindVariableField(props: any) {
    let bindingVal = props.bindingVal,
      param = props.paramName,
      variable = props.variable,
      variableName = props.variableName,
      variableScope = props.scope || {};

    if (stringStartsWith(bindingVal, "bind:")) {
      /* if binding is present, watch on the expression */
      // TODO
      // watchers[variableScope.$id][variableName].push(variableScope.$watch(bindingVal.replace("bind:", ""), function (newVal, oldVal) {
      //   /* don't perform any action if new value is coming as undefined(data source getting destroyed) */
      //   if ((newVal === oldVal && WM.isUndefined(newVal)) || (WM.isUndefined(newVal) && !WM.isUndefined(oldVal))) {
      //     return;
      //   }
      //   if (variable.category === "wm.Variable") {
      //     variable.dataSet[param] = newVal;
      //   } else if (variable.category === "wm.ServiceVariable" || variable.category === "wm.CrudVariable") {
      //     if (props.parentNode) {
      //       variable.dataBinding[props.parentNode][param] = newVal;
      //     } else {
      //       variable.dataBinding[param] = newVal;
      //     }
      //     /* if auto-update set for the variable, get its data */
      //     if (variable.autoUpdate && !WM.isUndefined(newVal) && WM.isFunction(variable.update)) {
      //       variable.update();
      //     }
      //   } else if (variable.category === "wm.LiveVariable") {
      //     if (variable.operation === "read") {
      //       variable.filterFields[param] = {
      //         'value': newVal
      //       };
      //       /* if auto-update set for the variable with read operation only, get its data */
      //       if (variable.autoUpdate && !WM.isUndefined(newVal) && WM.isFunction(variable.update)) {
      //         variable.update();
      //       }
      //     } else {
      //       variable.inputFields[param] = newVal;
      //       /* if auto-update set for the variable with read operation only, get its data */
      //       if (variable.autoUpdate && !WM.isUndefined(newVal)) {
      //         variable[variable.operation + 'Record']();
      //       }
      //     }
      //   } else if (variable.category === "wm.NotificationVariable" || variable.category === "wm.NavigationVariable") {
      //     variable.dataBinding[param] = newVal;
      //   } else if (variable.category === "wm.LoginVariable") {
      //     variable.dataBinding[param] = newVal;
      //     /* if auto-update set for the variable, get its data */
      //     if (variable.autoUpdate && !WM.isUndefined(newVal)) {
      //       variable.login();
      //     }
      //   } else if (variable.category === "wm.DeviceVariable") {
      //     variable[param] = newVal;
      //     if (variable.autoUpdate) {
      //       variable.invoke();
      //     }
      //   }
      // }));
    } else if (variable.category === "wm.LiveVariable") {
      /* binding is not present, apply the value written for binding */
      if (variable.operation === "read") {
        variable.filterFields[param] = {
          'value': bindingVal
        };
      } else {
        variable.inputFields[param] = bindingVal;
      }
    } else if (variable.category === "wm.Variable") {
      /* if there is already a value defined in the dataSet, give it preference over value in dataBinding */
      if (variable.dataBinding[param]) {
        variable.dataSet[param] = variable.dataSet[param] || variable.dataBinding[param];
      }
    } else if (variable.category === "wm.DeviceVariable") {
      variable[param] = bindingVal;
    }
  }

  /* function to update the binding for a variable */
  updateVariableBinding(variable: any, name: any, scope: any) {
    let bindMap, root: any;

    /*
     * new implementation: dataBinding is a flat array of binding objects with x-path targets
     * old implementation: dataBinding is a recursive map of binding objects
     * old implementation: dataBinding is an object map
     */
    if (Array.isArray(variable.dataBinding)) {
      bindMap = variable.dataBinding;
      root = variable.category === "wm.Variable" ? "dataSet" : "dataBinding";
      variable.dataBinding = {};
      if (bindMap[0] && Array.isArray(bindMap[0].fields)) {
        /* old projects(without migration): dataBinding is a recursive map of binding objects */
        bindMap.forEach((node: any) => {
          this.processBindNode(node, variable, scope, variable);
        });
      } else {
        /* new projects with flat bind map */
        bindMap.forEach((node: any) => {
          /* for static variable change the binding with target 'dataBinding' to 'dataSet', as the results have to reflect directly in the dataSet */
          if (variable.category === "wm.Variable" && node.target === 'dataBinding') {
            node.target = 'dataSet';
          }
          this.processBindObject(node, scope, root, variable);
        });
      }
    } else {
      /*
       * oldest implementation: loop over each variable-binding object to check for bindings
       * NOTE: Notification Variables still follow this structure, can not be removed
       */
      forEach(variable.dataBinding, (binding, param) => {
        if (typeof binding === 'object' && (variable.category === 'wm.ServiceVariable' || variable.category === 'wm.CrudVariable')) {
          forEach(binding, (subParamBinding, subParam) => {
            this.bindVariableField({ bindingVal: subParamBinding, paramName: subParam, variable: variable, variableName: name, parentNode: param, scope: scope });
          });
        }
        this.bindVariableField({ bindingVal: binding, paramName: param, variable: variable, variableName: name, scope: scope });
      });
    }

    // Process bindings for navigation variable's dataSet
    // TODO - needed?
    // if (runMode && variable.category === "wm.NavigationVariable" && WM.isArray(variable.dataSet)) {
    //   bindMap = variable.dataSet;
    //   root = "dataSet";
    //   variable.dataSet = {};
    //   /* new projects with flat bind map */
    //   bindMap.forEach(function (node) {
    //     processBindObject(node, scope, root, variable);
    //   });
    // }
  }

  /**
   * Old Implementation (DataBinding Recursive Structure)
   * processes a dataBinding object, if bound to expression, watches over it, else assigns value to the expression
   * @param node binding node object
   * @param parentNode parent object
   * @param scope scope of the variable
   * @param variable variable object
   */
  processBindNode(node: any, parentNode: any, scope: any, variable: any) {
    if (stringStartsWith(node.value, "bind:")) {
      // TODO
      // scope.$watch(node.value.replace("bind:", ""), function (newVal, oldVal) {
      //   if ((newVal === oldVal && WM.isUndefined(newVal)) || (WM.isUndefined(newVal) && (!WM.isUndefined(oldVal) || !WM.isUndefined(parentNode[node.name])))) {
      //     return;
      //   }
      //   parentNode[node.name] = newVal;
      //   processVariablePostBindUpdate(node.name, newVal, node.type, variable);
      // }, true);
    } else {
      if (isDefined(node.value)) {
        parentNode[node.name] = node.value;
        if (variable.category === "wm.LiveVariable") {
          /* binding is not present, apply the value written for binding */
          if (variable.operation === "read") {
            variable.filterFields[node.name] = {
              'value': node.value
            };
          } else {
            variable.inputFields[node.name] = node.value;
          }
        }
      }
      if (node.fields && node.fields.length) {
        parentNode[node.name] = isObject(parentNode[node.name]) ? parentNode[node.name] : {};
        forEach(node.fields, (field) => {
          this.processBindNode(field, parentNode[node.name], scope, variable);
        });
      }
    }
  }

  /**
   * This traverses the filterexpressions object recursively and process the bind string if any in the object
   * @param variable variable object
   * @param name name of the variable
   * @param scope scope of the variable
   */
  processFilterExpBindNode(filterExpressions: any) {
    this.traverseFilterExpressionObj(filterExpressions);
  }

  bindFilExpObj(obj: any, targetNodeKey: any, filterExpressions: any) {
    if (stringStartsWith(obj[targetNodeKey], "bind:")) {
      //Skip cloning for blob column
      // if (!includes(['blob', 'file'], obj.type)) {
      //   newVal = getClonedObject(newVal);
      // }
      //setting value to the root node
      if (obj) {
        //backward compatibility: where we are allowing the user to bind complete object
        if (obj.target === "dataBinding") {
          //remove the existing databinding element
          filterExpressions.rules = [];
          //now add all the returned values
          // forEach(newVal, (value, target) => {
          //   filterExpressions.rules.push({
          //     'target': target,
          //     'value': value,
          //     'matchMode': obj.matchMode || 'startignorecase',
          //     'required': false,
          //     'type': ''
          //   })
          // });
        } else {
          // obj[targetNodeKey] = newVal;
        }
      }
      // Utils.triggerFn(success, filterExpressions, newVal);
    }
  };

  traverseFilterExpressionObj(filterExpressions: any) {
    if (filterExpressions.rules) {
      forEach(filterExpressions.rules, (filExpObj, i): any => {
        if (filExpObj.rules) {
          this.traverseFilterExpressionObj(filExpObj);
        } else {
          if (filExpObj.matchMode === "between") {
            this.bindFilExpObj(filExpObj, "secondvalue", filterExpressions);
          }
          this.bindFilExpObj(filExpObj, "value", filterExpressions);
        }
      });
    }
  };

  /*
  * Trigger update on variable based on run/studio mode
  * */
  updateVariableData(variable: any, name: string, context: any, scope: any, options?: any) { // TO DO
    /* assign variable name to the variable object for later use */
    variable.name = name;
    // TODO: check if needed
    if (variable.init) {
      variable.init();
    }
    /* this copy is used by binding dialog in STUDIO mode */
    this.studioCopy[context][name] = variable;

    /* update variable bindings */
    // this.updateVariableBinding(variable, name, scope); -- TODO

    /* update variable bindings in case of live Variables */
    if (variable.operation == "read" && !isNil(variable.filterExpressions) && isObject(variable.filterExpressions)) {
      /* un-register previous watchers, if any */
      // watchers[scope.$id][name] = watchers[scope.$id][name] || [];
      // watchers[scope.$id][name].forEach(Utils.triggerFn);

      // let onSuccess = function (filterExpressions, newVal) {
      //   if (variable.operation === 'read') {
      //     /* if auto-update set for the variable with read operation only, get its data */
      //     if (variable.autoUpdate && !WM.isUndefined(newVal) && WM.isFunction(variable.update)) {
      //       _invoke(variable, 'update');
      //     }
      //   } else {
      //     /* if auto-update set for the variable with read operation only, get its data */
      //     if (variable.autoUpdate && !WM.isUndefined(newVal) && WM.isFunction(variable[variable.operation + 'Record'])) {
      //       _invoke(variable, variable.operation + 'Record');
      //     }
      //   }
      // };
      this.processFilterExpBindNode(variable.filterExpressions);
    }

    /*iterating over the collection to update the variables appropriately.*/
    if (variable.category === "wm.LiveVariable") {
      let varInstance = variable.owner === 'Page' ? this.variableInstanceCollection[context][name] : this.variableInstanceCollection['App'][name];
      // if a variable's owner is change on save, move the instance of variable accordingly
      if (!varInstance) {
        if (this.variableInstanceCollection['App'][name]) {
          this.variableInstanceCollection[context][name] = varInstance = this.variableInstanceCollection['App'][name];
          delete this.variableInstanceCollection['App'][name];
        } else if (this.variableInstanceCollection[context][name]) {
          this.variableInstanceCollection['App'][name] = varInstance = this.variableInstanceCollection[context][name];
          delete this.variableInstanceCollection[context][name];
        }
      }

      if (variable.startUpdate && isFunction(varInstance?.__update)) {
        varInstance.__update(variable, varInstance, options);
      } else {
        /*
          * In studio mode, DB and table related data is to be fetched and saved in the variable
          * So, getData is called in STUDIO mode for liva variables with all types of operations
          * since startUpdate is unset, table data is not required, hence skipFetchData flag is set
          */
        /* keeping the call in a timeout to wait for the widgets to load first and the binding to take effect */
        if (isFunction(varInstance?.__update)) {
          varInstance.__update(variable, varInstance, { skipFetchData: true });
        }
      }
    }
    // if (variable.category === "wm.ServiceVariable" || variable.category === "wm.CrudVariable") {
    //   if (runMode) {
    //     variable.canUpdate = true;
    //     if (variable.startUpdate) {
    //       processVariableStartUpdate(variable, scope);
    //     }
    //   } else {
    //     //fetching the meta data in design mode always
    //     if (WM.isFunction(variable.update)) {
    //       variable.update(options);
    //     }
    //   }
    // } else if (variable.category === "wm.WebSocketVariable") {
    //   if (variable.startUpdate && runMode) {
    //     processVariableStartUpdate(variable, scope);
    //   }
    // } else if (variable.category === "wm.LiveVariable") {
    //   migrateOrderBy(variable);
    //   if (runMode) {
    //     variable.canUpdate = true;
    //     if (variable.startUpdate) {
    //       processVariableStartUpdate(variable, scope);
    //     }
    //   } else {
    //     if (variable.startUpdate && WM.isFunction(variable.update)) {
    //       $timeout(function () {
    //         variable.update();
    //       }, null, false);
    //     } else {
    //       /*
    //        * In studio mode, DB and table related data is to be fetched and saved in the variable
    //        * So, getData is called in STUDIO mode for liva variables with all types of operations
    //        * since startUpdate is unset, table data is not required, hence skipFetchData flag is set
    //        */
    //       $timeout(function () {
    //         /* keeping the call in a timeout to wait for the widgets to load first and the binding to take effect */
    //         if (WM.isFunction(variable.update)) {
    //           variable.update({ skipFetchData: true });
    //         }
    //       }, null, false);
    //     }
    //   }
    // } else if (variable.category === "wm.LoginVariable") {
    //   if (runMode && variable.startUpdate) {
    //     processVariableStartUpdate(variable, scope);
    //   }
    // } else if (variable.category === "wm.TimerVariable") {
    //   if (runMode && variable.autoStart) {
    //     processVariableStartUpdate(variable, scope);
    //   }
    // } else if (variable.category === "wm.DeviceVariable") {
    //   if (runMode && variable.startUpdate) {
    //     processVariableStartUpdate(variable, scope);
    //   }
    // }
  }

  /* Extend each variable in the provided collection with all the properties of that type
      *  The properties are fetched from the baseFactory.
      */
  extendVariables(variables: any) {
    // extend the variables with all properties not found in the variable
    each(variables, (variable: any, name: string) => {
      variables[name] = Object.assign(this.baseVariablePropertyFactory.getProperties(variable.category), variable);

      // removing dataSet for live variable
      if (!this.runMode && variable.category === "wm.LiveVariable") {
        variables[name].dataSet = [];
      } else if (this.runMode && (variable.category === "wm.ServiceVariable" || variable.category === "wm.WebSocketVariable" || variable.category === "wm.CrudVariable")) {
        // TO DO

        // Object.defineProperty(variables[name], '_wmServiceOperationInfo', {
        //   get: function () {
        //     return MetaDataFactory.getByOperationId(variables[name].operationId, variables[name]._prefabName);
        //   },
        //   configurable: true
        // });

        // service variable migration for old service variables not having controller names
        if (this.runMode && !variable.controller && variable.operationId) {
          variables[name].controller = variable.operationId.split('_')[0].replace(/Controller$/, '');
        }
      }
    });

    return variables;
  }

  /*Function to delete the specified variable*/
  deleteVariable(name: any, pageName?: any) {
    let i, pageContext, owner;
    /*Check if pageName is specified*/
    if (pageName) {
      /*If "name" is specified, delete the specified variable from the page.
      * Else, delete all the variables of that page.*/
      if (name && !includes(this.CRUDMAP.DELETE[pageName], name)) {
        if (!this.CRUDMAP.DELETE[pageName])
          this.CRUDMAP.DELETE[pageName] = []
        this.CRUDMAP.DELETE[pageName].push(name);
        delete this.variableCollection[pageName][name];
        delete this.variableInstanceCollection[pageName][name];
        /* if in studio mode remove the studio copy of variable*/
        // TODO- needed?
        // if (CONSTANTS.isStudioMode) {
        //   delete returnObject[name];
        //   delete this.studioCopy[pageName][name];
        // }
        delete this.studioCopy[pageName][name];
      } else {
        each(this.variableCollection[pageName], (variable) => {
          if (!includes(this.CRUDMAP.DELETE[pageName], variable.name) && this.CRUDMAP.DELETE[pageName]) {
            this.CRUDMAP.DELETE[pageName].push(variable.name);
          }
        });
        delete this.variableCollection[pageName];
        delete this.variableInstanceCollection[pageName];
        /* if in studio mode remove the studio copy */
        // TODO- needed?
        // if (CONSTANTS.isStudioMode) {
        //   delete this.studioCopy[pageName];
        // }
        delete this.studioCopy[pageName];
      }
      return;
    }
    /* Condition: Checking for existence of the variable name inside each category, deleting if found */
    for (i in this.variableCollection) {
      if (this.variableCollection.hasOwnProperty(i) && this.variableCollection[i].hasOwnProperty(name)) {
        owner = this.variableCollection[i][name].owner === VARIABLE_CONSTANTS.OWNER.APP ? VARIABLE_CONSTANTS.OWNER.APP : this.pageService.activePageName;
        if (!includes(this.CRUDMAP.DELETE[owner], name)) {
          this.CRUDMAP.DELETE[owner].push(name);
        }
        delete this.variableCollection[i][name];
        delete this.variableInstanceCollection[i][name];
        /* if in studio mode remove the studio c
        opy of variable*/
        // TODO - CONSTANTS.isStudioMode && add it to below condition
        if (this.studioCopy[i]) {
          delete this.studioCopy[i][name];
        }
        /*if the context is a page and not a scope id, return the page context*/
        if ((this.projectService.getPageNames() as any).indexOf(i) > -1) {
          pageContext = i;
        }
      }
    }

    /*if deleted variable page context is available, return it else, return false*/
    if (pageContext) {
      return pageContext;
    }
    return false;
  }

  initServiceTypesList(collectionType: string) {
    this.serviceTypes = getServiceTypesByCollectionType(collectionType);
    // service type groups
    let serviceTypeGroups: any = [],
      groupName: string,
      groupObj;
    const serviceTypesGroup = VARIABLE_CONSTANTS.SERVICE_TYPE_GROUP;
    this.serviceTypes.forEach((serviceType: keyof ServiceTypeGroup) => {
      if( serviceType !== "device" || (serviceType === "device" && this.projectService.isNativeMobileApplicationType())){
        groupName = serviceTypesGroup[serviceType] || '';
        groupObj = find(serviceTypeGroups, { id: groupName });
        if (!groupObj) {
          groupObj = serviceTypeGroups[serviceTypeGroups.push({
            id: groupName,
            serviceTypes: []
          }) - 1];
        }
        groupObj.serviceTypes.push(serviceType);
      }
    });
    this.serviceTypeGroups = serviceTypeGroups;
  }

  /* function to get page variables for a specified page*/
  getPageVariables(pageName: string, skipEmptyCRUD?: boolean) {
    return new Promise((res, rej) => {
      if (!this.runMode && !skipEmptyCRUD) {
        /*Initializing map with pageName context*/
        this.CRUDMAP.CREATE[pageName] = [];
        this.CRUDMAP.DELETE[pageName] = [];
        this.CRUDMAP.UPDATE[pageName] = [];
        this.CRUDMAP.MOVE[pageName] = [];
      }
      /* check for existence */
      if (this.variableCollection !== null && this.variableCollection[pageName] && (this.reloadRequired && !includes(this.reloadRequired, pageName))) {
        return res(this.variableCollection[pageName]);
      }

      let requestParams = {
        pageName: pageName,
        projectId: this.projectService.getProjectId()
      };
      (this.getVariablesMap(requestParams) as Promise<any>).then((variables) => {
        remove(this.reloadRequired, (page) => {
          return page === pageName;
        });
        if (!isObject(variables)) {
          variables = {};
        }

        this.setPageVariables(pageName, variables);
        return res(variables);
      }).catch((errMsg) => {
        this.setPageVariables(pageName, undefined);
        rej(errMsg);
      });
    });
  }

  /**
   * @description
   * get map of variable objects
   *
   * @param {object} params object containing parameters for the request (else throws an error message)
   */
  get(params: any) {
    let action = 'getAppVariables';
    let urlParams: any = {
      projectId: params.projectId
    };

    if (params.pageName !== 'App') {
      action = 'getPageVariables';
      urlParams.pageName = params.pageName;
    }

    return this.wmHttpService.execute({
      target: "VariableService",
      action: action,
      pathParams: urlParams
    });
  }

  getVariablesMap(params: any) {
    let action = 'getAppVariables';
    let urlParams: any = {
      projectId: params.projectId
    };

    if (params.pageName !== 'App') {
      action = 'getPageVariables';
      urlParams.pageName = params.pageName;
    }
    return this.getVariables(urlParams, action);
  }

  /* stores the unsaved variables into the variable collection */
  storeUnsavedVariable() {
    let variableOwner = this.unsavedVariable.owner === "Page" ? this.pageService.activePageName : "App";
    this.store(variableOwner, this.unsavedVariable.name, this.unsavedVariable);
    /* empty the stack */
    this.unsavedVariable = undefined;
  }

  getVariableMetaInfo(variableObject: any) {
    let info,
      subType = '',
      WEBSOCKET = "WebSocket",
      SOAP = "SOAP",
      REST = "REST",
      QUERY = "Query",
      PROCEDURE = "Procedure";
    switch (variableObject.category) {
      case "wm.LiveVariable":
        subType = variableObject.operation;
        info = variableObject.liveSource + "/" + variableObject.type;
        break;
      case "wm.CrudVariable":
      case "wm.ServiceVariable":
        info = variableObject.service + "/" + variableObject.operation;
        if (variableObject.serviceType === VARIABLE_CONSTANTS.SERVICE_TYPE_DATA) {
          if (variableObject.controller === 'QueryExecution') {
            subType = QUERY;
          } else if (variableObject.controller === 'ProcedureExecution') {
            subType = PROCEDURE;
          }
        } else if (variableObject.serviceType === VARIABLE_CONSTANTS.SERVICE_TYPE_SOAP) {
          subType = SOAP;
        } else if (variableObject.serviceType === VARIABLE_CONSTANTS.SERVICE_TYPE_REST) {
          subType = REST;
        } else if (variableObject.serviceType === VARIABLE_CONSTANTS.SERVICE_TYPE_WEBSOCKET) {
          subType = WEBSOCKET;
        }
        break;
      case "wm.WebSocketVariable":
        subType = WEBSOCKET;
        info = variableObject.service + "/" + variableObject.operation;
        break;
      case "wm.DeviceVariable":
        info = variableObject.service + "/" + variableObject.operation;
        break;
      case "wm.NavigationVariable":
        info = variableObject.operation;
        break;
      case "wm.NotificationVariable":
        info = variableObject.operation;
        break;
    }

    return {
      subType: subType,
      info: info
    };
  }

  getVariables(connectionParams: any, action: string) {
    return this.wmHttpService.execute({
      target: 'VariableService',
      action: action,
      pathParams: connectionParams
    });
  }

  getVariableCollection() {
    return this.variableCollection;
  }

  getStudioCopy() {
    return this.studioCopy;
  }

  /*function to create a variable*/
  createVariable(type: string, options: any, name?: string, overWrite?: boolean) {
    /* type sanity checking */
    type = type || "wm.Variable";
    let variableObj = {},
      defaultName = '';

    options = typeof options === 'object' ? options : {};

    /* if name prefix provided, create another category and iterator for that category*/
    if (name) {
      defaultName = this.generateUniqueName(type, name, overWrite);
    } else {
      defaultName = this.generateUniqueName(type, undefined, undefined, options.unsavedVariableName);
    }

    /* create the variable object with its basic properties and return it */
    Object.assign(variableObj, this.baseVariablePropertyFactory.getProperties(type), { name: defaultName }, options);
    let owner = this.pageService.activePageName;
    // If app level variables are created -ex: logout,login variables
    // then the service instance is created with incorrect owner(if owner is not provided).
    if(options.owner === VARIABLE_CONSTANTS.OWNER.APP){
      owner = VARIABLE_CONSTANTS.OWNER.APP;
    }
    this.createServiceInstance(owner, defaultName, type, variableObj);
    return variableObj;
  }

  /* function to create default non-conflicting name for a variable */
  generateUniqueName(category: string, name: any, overWrite?: any, unsavedVariableName?: any): any {
    let defaultName,
      nameIteratorKey = category;
    if (name) {
      nameIteratorKey = name;
      this.variableNameIterator[nameIteratorKey] = this.variableNameIterator[nameIteratorKey] || 0;
      defaultName = name + (this.variableNameIterator[nameIteratorKey] || '');
    } else {
      defaultName = this.variableCategoryToNameMap[category] + this.variableNameIterator[category];
    }

    if (!this.isExists(defaultName, true, unsavedVariableName) || overWrite) {
      return defaultName;
    }

    /* increment the iterator for the category and look for unique name again*/
    this.variableNameIterator[nameIteratorKey] += 1;
    return this.generateUniqueName(category, name);
  }

  /* function to check if variable with specified name exists in the collection*/
  isExists(variableName: string, caseSensitive: boolean = false, unsavedVariableName?: any) {
    const variables = this.variableCollection;
    let arrOfVariables, isPrefabTemplate = this.projectService.isPrefabType();
    arrOfVariables = isPrefabTemplate ? keys(variables[this.pageService.activePageName]) : union(keys(variables[VARIABLE_CONSTANTS.OWNER.APP]), keys(variables[this.pageService.activePageName]));
    if (unsavedVariableName) {
      arrOfVariables.push(unsavedVariableName);
    }
    return isDuplicateName(arrOfVariables, variableName, caseSensitive);
  }

  createCrudVariable(variableDetails: any, overWrite: any, createNewVariable: any) {
    /* call base service function to create the variable */
    let variableCategory = "wm.CrudVariable",
      defaultName = variableDetails.name || initCaps(variableDetails.service) + initCaps(variableDetails.operation),
      createdVariable: any,
      variableName,
      variableOwner,
      bindMapCollection;

    /*If the default variable does not exist, create it.
     * Else, simply return the variable name.*/
    if (!this.isExists(defaultName) || overWrite || createNewVariable) {
      createdVariable = this.createVariable(variableCategory, { owner: variableDetails.owner || "Page" }, defaultName, overWrite);
      variableName = createdVariable.name;
      variableOwner = (createdVariable.owner === VARIABLE_CONSTANTS.OWNER.PAGE) ? this.pageService.activePageName : null;

      /*Set the "service" and "operation" properties of the service-variable.*/
      createdVariable.service = variableDetails.service;
      createdVariable.operation = variableDetails.operation;
      createdVariable.operationType = variableDetails.operationType;
      createdVariable.crudOperationId = variableDetails.crudOperationId;
      createdVariable.serviceType = variableDetails.serviceType;
      createdVariable.category = variableCategory;
      createdVariable.isDefault = false;
      createdVariable.controller = variableDetails.controller;
      createdVariable.operationId = variableDetails.operationId;
      createdVariable.type = variableDetails.returnType;

      forEach(['maxResults', 'startUpdate', 'autoUpdate', 'isList'], (property) => {
        if (isDefined(variableDetails[property])) {
          createdVariable[property] = variableDetails[property];
        }
      });

      /* insert sample param values if provided */
      bindMapCollection = createdVariable.dataBinding;
      forEach(variableDetails.sampleParamValues, (val, key) => {
        bindMapCollection.push({
          "target": key,
          "value": val,
          "type": "java.lang.String"
        });
      });
      /* Store the variable in proper category */
      this.store(variableOwner, variableName, createdVariable, true);
    } else {
      variableName = defaultName;
    }

    /*Return the name of the newly created variable.*/
    return variableName;
  }

  /*
 * empties the dataBinding for selected variable
 * called on creation of a new service variable
 * @param {selectedVariable} object having details of selected variable
 */
  emptyDataBindingObject(selectedVariable: any) {
    /*remove properties for previous selected operation's params*/
    Object.keys(selectedVariable.propertyObj).forEach((propertyName: string) => {
      let propertyObject: any = selectedVariable.propertyObj[propertyName];
      if (propertyObject.dataBinding) {
        delete this.selectedVariable.propertyObj[propertyName];
        selectedVariable.propertyNames.splice(selectedVariable.propertyNames.indexOf(propertyName), 1);
      }
    });
  }

  /* function to add a parameter to the selected variable properties & make it visible in the UI */
  addParamToProperties(param: any, variable: any, dataSetSubGroup: any, dataTypes: any, parentNode?: any, initVal?: any) {
    param.name = param.name || (param.parameterType && param.parameterType.toLowerCase());
    let paramType = extractType(param.typeRef),
      paramName = this.PROPERTY_PREFIX + param.name;
    if (dataSetSubGroup.properties.indexOf(paramName) === -1) {
      dataSetSubGroup.properties.push(paramName);
    }
    paramType = isNumberType(paramType) ? 'number' : paramType;

    /* if param typeRef not present, make it bindable to all basic types*/
    if (!dataTypes[param.typeRef]) {
      paramType = 'string, number, boolean';
    }

    if (parentNode) {
      variable.variableObject.dataBinding[parentNode] = variable.variableObject.dataBinding[parentNode] || {};
      variable.variableObject.dataBinding[parentNode][param.name] = variable.variableObject.dataBinding[parentNode][param.name] || '';
    } else {
      variable.variableObject.dataBinding[param.name] = variable.variableObject.dataBinding[param.name] || initVal || '';
    }

    if (!initVal) {
      variable.propertyNames.push(paramName);
      variable.propertyObj[paramName] = {
        "type": paramType,
        "modelObj": parentNode ? this.selectedVariable.variableObject.dataBinding[parentNode] : this.selectedVariable.variableObject.dataBinding,
        "modelKey": param.name,
        "dataBinding": true,
        "isList": param.isList,
        "displayName": param.name
      };
    } else {
      variable.propertyNames.splice(variable.propertyNames.indexOf(paramName));
      delete variable.propertyObj[paramName];
    }

    /* check for auth-params for a REST service variable */
    if (stringStartsWith(param.name, 'wm_auth_')) {
      variable.propertyObj[paramName].displayName = variable.propertyObj[paramName].displayName.replace('wm_auth_', '');
    }
  }

  /**
   * if the target key has a "." (e.g. "my.param"), it should be wrapped within square braces as "['my.param']"
   * this is done, so that at run time, the computed value against this binding is assigned as
   *      {"my.param": "value"}
   * and not as
   *      {
   *          "my": {
   *              "param": "value"
   *          }
   *      }
   * @param key
   * @returns {string}
   */
  wrapTargetKey(key: any) {
    return "['" + key + "']";
  }

  extractRESTSampleResponseData(serviceDetails: any) {
    let responseData = serviceDetails.httpRequestDetails.sampleHttpResponseDetails;
    responseData = responseData.convertedResponse || responseData.responseBody;
    responseData = getValidJSON(responseData);
    return responseData;
  }

  getRestServiceDetails(service: any, success: any, error?: any) {
    this.variableDialogMsg = {
      'type': 'loading',
      'caption': this.locale.MESSAGE_SERVICE_INFO_LOADING
    };
    (this.webService.getRESTDetails({
      urlParams: { 'projectID': this.projectService.getProjectId(), 'serviceID': service }
    }) as Promise<any>).then((response: any) => {
      this.variableDialogMsg = null;
      triggerFn(success, response);
    }, (errMsg) => {
      this.variableDialogMsg = null;
      triggerFn(error, errMsg);
    });
  }

  /**
   * If it is file upload type variable then enable onProgress & onAbort events
   * @param selectedVariable
  */
  isFileUploadTypeVar(selectedVariable: any) {
    Object.keys(VARIABLE_CONSTANTS.EVENT).forEach((eventName: any) => {
      let event = (VARIABLE_CONSTANTS.EVENT as any)[eventName]
      if ((event === 'onAbort' || event === 'onProgress')) {
        forEach(selectedVariable.propertyObj.dataBinding.modelObj.dataBinding, (dataBinding: any): any => {
          if (dataBinding && dataBinding.type === 'file') {
            selectedVariable.propertyObj[event].hide = false;
            return false;
          } else {
            selectedVariable.propertyObj[event].hide = true;
          }
        });
      }
    });
  }

  //To check if the source of the variable exists
  sourceExists() {
    let source;
    if (this.selectedVariable.metaInfo) {
      source = this.selectedVariable.metaInfo.split('/');

      //Check if it is a live variable
      if (this.selectedVariable.serviceType === 'database') {
        let livesource = source[0],
          table = source[1];
        //Check if the database exists or not and if databse exists then check if table exists or not
        if (this.selectedVariable.propertyObj.liveSource.options) {
          if (!this.selectedVariable.propertyObj.liveSource.options[livesource]) {
            this.selectedVariable.serviceError = true;
            this.selectedVariable.serviceErrorMessage = replace(this.locale["DATABASE_DOESNT_EXIST"], [livesource]);
          } else if (this.selectedVariable.propertyObj.type.options && !this.selectedVariable.propertyObj.type.options[table]) {
            this.selectedVariable.methodError = true;
            this.selectedVariable.serviceErrorMessage = replace(this.locale["TABLE_DOESNT_EXIST"], [table, livesource]);
          }
        }
      } else {
        let service = source[0],
          method = source[1],
          methodExists = false;
        //Check if the service exists or not and if service exists then check if method exists or not
        if (this.selectedVariable.propertyObj.service.options) {
          if (!this.selectedVariable.propertyObj.service.options[service]) {
            this.selectedVariable.serviceError = true;
            this.selectedVariable.serviceErrorMessage = replace(this.locale["SERVICE_DOESNT_EXIST"], [service]);
          } else if (this.selectedVariable.propertyObj.operation && this.selectedVariable.propertyObj.operation.options) {
            if (isEmpty(this.selectedVariable.propertyObj.operation.options)) {
              methodExists = true;
            }
            if (this.selectedVariable.variableObject.category === "wm.CrudVariable") {
              forEach(this.selectedVariable.propertyObj.operation.options, (serviceMethod: any): any => {
                if (serviceMethod.type === method) {
                  methodExists = true;
                  return false;
                }
              });
            } else if (get(this.selectedVariable, 'variableObject.serviceType') === 'OpenAPIService') {
              forEach(this.selectedVariable.propertyObj.operation.options, (serviceMethod: any): any => {
                if (get(this.selectedVariable, 'variableObject.operation').indexOf(serviceMethod.name) > -1) {
                  methodExists = true;
                  return false;
                }
              });
            } else {
              forEach(this.selectedVariable.propertyObj.operation.options, (serviceMethod: any): any => {
                if (serviceMethod.name === method) {
                  methodExists = true;
                  return false;
                }
              });
            }
            if (!methodExists) {
              this.selectedVariable.methodError = true;
              this.selectedVariable.serviceErrorMessage = replace(this.locale["METHOD_DOESNT_EXIST"], [method, service]);
            }
          }
        }
      }
    }
  };


  /*change handler currently used only for updating '_isUpdated' flag*/
  markUpdated() {
    if (this.selectedVariable) {
      this.selectedVariable.variableObject._isUpdated = true;
    }
  };

  /**
 * Traverses recursively the filterExpressions object and returns an array of all the rule objects.
 * @param filterExpressions - recursive rule Object
 * @returns {Array}
 */
  getAllFilterExpressions(filterExpressions: any) {
    let expressions: any = [];

    var traverseCallbackFn = (filExpObj: any) => {
      expressions.push(filExpObj);
    };
    this.traverseFilterExpressions(filterExpressions, traverseCallbackFn);

    return expressions;
  }

  traverseFilterExpressions(filterExpressions: any, traverseCallbackFn: any) {
    if (filterExpressions.rules) {
      filterExpressions.rules.forEach((filExpObj: any) => {
        if (filExpObj.rules) {
          this.traverseFilterExpressions(filExpObj, traverseCallbackFn);
        } else {
          triggerFn(traverseCallbackFn, filExpObj);
        }
      });
    }
  }

  /**
   * Creating a set of all the columns for the entity, if there is any column missing then add it here and return
   * the final list of column objects
   * @param props - current live variable properties map columns
   * @param bindedProps - an array of all the rule Objects
   * @returns {Array}
   */
  getAllPropertyBindings(props: any, bindedProps: any) {
    let normalisedArray: any = [];
    props.forEach((prop: any) => {
      let existingObj = find(bindedProps, (o) => o.target === prop.field);
      if (existingObj) {
        normalisedArray.push(existingObj);
      } else {
        normalisedArray.push({ "target": prop.field, "type": prop.dataType });
      }
    });
    return normalisedArray;
  }

  /**
   * clears all properties under the bindable subgroups
   * e.g. clears properties for subgroups
   *  - 'Inputs', 'inputfields', 'filterfields' under 'data' group
   *  - 'Inputs' under 'properties' group
   */
  clearOldBindingProps(target: any) {
    this.propertyGroups.forEach((group: any) => {
      group.subGroups.forEach((subGroup: any) => {
        if (includes(subGroup.propertyTarget, target) || !target) {
          subGroup.properties = [];
        }
      });
    });

    Object.keys(this.selectedVariable.propertyObj).forEach((prop: any) => {
      let obj: any = this.selectedVariable.propertyObj[prop];
      if (obj.dataBinding && obj.bindingTarget === target) {
        delete this.selectedVariable.propertyObj[prop];
      }
    });
  }

  getWidgetType(type: any) {
    let supportedWidgetTemplates = ['string', 'number', 'boolean', 'date', 'datetime', 'list'];
    if (includes(supportedWidgetTemplates, type)) {
      return type;
    }
    return 'string';
  }

  /**
   * Returns the subgroup object against the passed subGroup name under passes group object
   * @param group, parent group name
   * @param subGroup, subgroup name
   * @returns {*}
   */
  getSubGroupObjByName(group: any, subGroup: any) {
    let propertySubGroupObj;
    this.propertyGroups.forEach((parentGroup: any) => {
      if (parentGroup.name === group) {
        parentGroup.subGroups.forEach((subGroupObj: any) => {
          if (subGroupObj.name === subGroup) {
            propertySubGroupObj = subGroupObj;
          }
        });
      }
    });

    return propertySubGroupObj;
  }

  /* function to get application variables */
  getAppVariables(): any {
    return new Promise((res, rej) => {
      /* check for existence */
      /*Initializing map with 'APP' context*/
      this.CRUDMAP.CREATE[VARIABLE_CONSTANTS.OWNER.APP] = [];
      this.CRUDMAP.DELETE[VARIABLE_CONSTANTS.OWNER.APP] = [];
      this.CRUDMAP.UPDATE[VARIABLE_CONSTANTS.OWNER.APP] = [];
      this.CRUDMAP.MOVE[VARIABLE_CONSTANTS.OWNER.APP] = [];

      if (this.variableCollection !== null && this.variableCollection[VARIABLE_CONSTANTS.OWNER.APP] && (this.reloadRequired && !includes(this.reloadRequired, 'App'))) {
        return res([this.variableCollection[VARIABLE_CONSTANTS.OWNER.APP]]);
      }

      let requestParams = {};
      requestParams = {
        pageName: VARIABLE_CONSTANTS.OWNER.APP,
        projectId: this.projectService.getProjectId()
      };
      (this.get(requestParams) as Promise<any>).then((variables) => {
        if (typeof variables !== 'object') {
          variables = {};
        }
        remove(this.reloadRequired, (page) => {
          return page === 'App';
        });
        return res([variables, true]);
      }).catch((errMsg) => {
        rej(errMsg);
      });
    });
  }

  /* function to initialize variables for passed page */

  initAppVariables() {
    return new Promise<void>((resolve, reject) => {
      this.variableCollection = this.variableCollection || {};
      this.initVariableNameMap();
      this.resetVariableNameIterator();
      /* get application level variables */
      this.getAppVariables().then((res: any) => {
        let appVariables: any = res[0];
        let freshVariables: any = res[1];
        /*if the file is empty, initialize the collection to empty object*/
        if (typeof appVariables !== 'object') {
          appVariables = {};
        }

        /* extend and update the app variables only if freshly loaded */
        if (freshVariables) {
          this.register(VARIABLE_CONSTANTS.OWNER.APP, appVariables, true);
        }
        resolve();
      }).catch((errMsg: any) => {
        /* initialize the global variables collection to empty */
        this.variableCollection[VARIABLE_CONSTANTS.OWNER.APP] = {};
        reject();
        // TO DO
        // this.pageScopeMap[VARIABLE_CONSTANTS.OWNER.APP] = $rootScope;
      });
    });
  }

  /**
   * Loads the Input Params for passed page
   * For the loaded params, appends binding objects under the 'data' group
   * Merge existing bindings (if any)
   * @param pageName
   */
  loadPageDataParams(pageName: any) {
    let pageInfo = this.projectService.getPageInfo(pageName),
      pageParams = pageInfo.params,
      properties = [];
    properties = map(clone(pageParams), (obj) => {
      obj.target = obj.name;
      return obj;
    });
    /* merge the existing bindings with new(required bindings) */
    this.prepareBindings(properties, 'dataSet');
    this.addBindingsToProperties('dataSet');
  }


  /*
  * Method to handle variable event option change.
  * if new selected event is a NEW variable, the new variable is created
  * @param {propertyName} string event name
  * @param {propertyValue} string event value
  */
  onEventChange(eventName: any, eventValue: any) {
    let selectedVariableObject = this.selectedVariable.variableObject,
      propertyObject = this.selectedVariable.propertyObj,
      isNewVariable = this.selectedVariable.isNew,
      varName: any = selectedVariableObject.name,
      eventMessage,
      varDetails: any;

    propertyObject[eventName].modelObj[propertyObject[eventName].modelKey] = eventValue;
    if (eventValue === WIDGET_CONSTANTS.EVENTS.NO_EVENT || !intersection(eventValue.split(';'), WIDGET_CONSTANTS.EVENTS_OPTIONS)) {
      /*Hiding Info Message*/
      // toggleMessage(false); -- TO DO
    } else {
      /* if category not found return */
      if (includes(eventValue, WIDGET_CONSTANTS.EVENTS.JAVASCRIPT)) {
        /*if the value of the variable event is javascript function, then push the variable name
         * to an array to save them*/
        if (this.variablesForSave.indexOf(varName) === -1) {
          this.variablesForSave.push(varName);
        }
        this.isVariableEventChanged = true;
        //appending prefix content
        eventMessage = replace(this.locale.MESSAGE_INFO_OPEN_SCRIPT_FILE_PREFIX, [selectedVariableObject.owner, eventName]);
        //appending script link
        eventMessage = `<span>${eventMessage}</span> <a id="variableJSEvt" style="cursor:pointer">Click here</a>`;
        //appending suffix content
        eventMessage = `${eventMessage} <span>${this.locale.MESSAGE_INFO_OPEN_SCRIPT_FILE_SUFFIX}`;
        this.variableDialogMsg = {
          'type': 'info',
          'caption': eventMessage
        };
        this.jsEventsInfo.push(
          {
            event: eventName,
            variableName: varName,
            options: {
              'args': undefined,
              'eventPrefix': varName + eventName,
              'openScript': false,
              'variable': this.selectedVariable.variableObject,
              'onSuccess': (data: any) => {
                const owner = data.variable.owner === 'Page' ? this.pageService.activePageName : 'App';
                this.executeCrudOp(owner);
              }
          }, isVariableEvt: true
        });
        setTimeout(() => {
          $('#variableModal #variableMessage a').one('click', () => {
            this.jsEventsInfo.forEach((eventItem:any)=>{
              eventItem.options['openScript'] = true;
            });
            const evtObjIndex = this.jsEventsInfo.findIndex((item: any) => item.variableName === this.selectedVariable.variableObject.name);
            const evtObj = this.jsEventsInfo[evtObjIndex];
            if (evtObj)
              evtObj.options['openScript'] = true;
            this.jsEventsInfo.splice(evtObjIndex, 1);
            runtimeEventManager.emit('save-variables');
            runtimeEventManager.emit('add-event-handler', evtObj);
          });
        }, 0);

      } else {
        this.variableDialogMsg = null;
        /* if current variable is a new variable(unsaved), storing the variable temporarily */
        if (this.selectedVariable.isNew) {
          this.storeCurrentVariable(selectedVariableObject);
        }

        /* creating new variable using category obtained */
        varDetails = StudioUtils.getVariableDetails(eventValue);
        if (varDetails.category) {
          if (varDetails.type === 'data') {
            this.initServiceTypesList('data');
          } else {
            this.initServiceTypesList('action');
            this.isVariableDialog = true;
          }
          this.prevSelectedVariable = cloneDeep(this.selectedVariable);
          this.selectedVariable.variableObject._isUpdated = undefined;
          this.selectedEvt = eventName;
          this.dialogService.open('addVariableModal');
        }
      }
    }
  };

  getEventName(operation: string) {
    let eventName;
    switch (operation) {
      case 'read':
        eventName = VARIABLE_CONSTANTS.EVENT.BEFORE_LIST_RECORDS;
        break;
      case 'insert':
        eventName = VARIABLE_CONSTANTS.EVENT.BEFORE_INSERT_RECORD;
        break;
      case 'update':
        eventName = VARIABLE_CONSTANTS.EVENT.BEFORE_UPDATE_RECORD;
        break;
      case 'delete':
        eventName = VARIABLE_CONSTANTS.EVENT.BEFORE_DELETE_RECORD;
        break;
      default:
        eventName = VARIABLE_CONSTANTS.EVENT.BEFORE_UPDATE;
    }
    return eventName;
  }

  /*function to create event listeners for the variables whose event values are javascript functions*/
  createVariableEventListeners(variable: any, scriptContent: any) {
    let eventListener = '',
      events,
      prefix: any,
      params: any,
      eventsObj,
      customEvents,
      variableName = variable.name;
    /*iterate over the variables, which need to be saved after event change and
    * create the event listeners*/
    let isPageVariable = (variable.owner !== VARIABLE_CONSTANTS.OWNER.APP);

    /* check if any events assigned to the created variable */
    forEach(VARIABLE_CONSTANTS.EVENTS, (event) => {
      if (includes(variable[event], WIDGET_CONSTANTS.EVENTS.JAVASCRIPT)) {
        events = variable[event] && variable[event].split(';');
        if (event === VARIABLE_CONSTANTS.EVENT.BEFORE_UPDATE) {
          eventsObj = (variable.category === "wm.LiveVariable" && variable.operation === "read")
            ? getNewEventsObject(variableName + this.getEventName(variable.operation), events, '(variable, dataFilter, options)')
            : getNewEventsObject(variableName + this.getEventName(variable.operation), events, '(variable, inputData, options)');
        } else {
          eventsObj = getNewEventsObject(variableName + event, events, '(variable, data, options)');
        }
        customEvents = eventsObj.customEvents;
        variable[event] = eventsObj.events.join(';');

        if (isPageVariable) {
          let pageInfo = this.projectService.getPageInfo(this.pageService.activePageName);
          prefix = get(this.projectService, 'projectDetails.type') === 'PREFAB' ? (pageInfo?.type === 'PARTIAL' ? 'Partial.' : 'Prefab.') : pageInfo?.type === 'PAGE' ? 'Page.' : 'Partial.';
        } else {
          prefix = 'App.';
        }

        if (event === VARIABLE_CONSTANTS.EVENT.BEFORE_UPDATE) {
          params = (variable.category === "wm.LiveVariable" && variable.operation === 'read') ? '(variable, dataFilter, options)' : '(variable, inputData, options)';
        } else if (event === VARIABLE_CONSTANTS.EVENT.PROGRESS || event === VARIABLE_CONSTANTS.EVENT.ABORT) {
          params = '(variable, data, event)';
        } else {
          params = '(variable, data)';
        }
        /* add the event listener if it doesn't exist already */
        forEach(customEvents, (eventName) => {
          if (scriptContent.indexOf(eventName) === -1) {
            eventListener += prefix + eventName + ' = function' + params + '{\n\t\n' + '};\n';
          }
        });
      }
    });
    this.updateVariable(variable.name, variable);//Updating variable props using service
    // $rootScope.saveVariables = true;

    return { "eventListener": eventListener, "eventName": customEvents && customEvents[0] };
  }

  /*
  * Function to push the provided variable in a temporary collection.
  * @param {variable} variable to store
  */
  storeCurrentVariable(variable: any) {
    /*assigning variable category*/
    variable.category = this.selectedVariable.category;

    this.unsavedVariable = variable;
  }

  /* function to update variable values in $rootScope */
  updateVariableValues(activePageName: any, isUpdatePageVariables?: any) {

    /*If the flag to update only page level variables is set, then do not trigger the update function for app-level variables*/
    if (!isUpdatePageVariables) {
      /* app level variables */
      this.updateContextVariables(VARIABLE_CONSTANTS.OWNER.APP);
    }

    /* page level variables */
    if (activePageName) {
      this.updateContextVariables(activePageName);
    }
  }

  /*Function to check if map is empty in provided context*/
  isCrudEmpty(map: any, pageName: any) {
    /*If the map for particular page doesn't exist then considering its empty*/
    return !(map.CREATE[pageName]?.length || map.UPDATE[pageName]?.length || map.DELETE[pageName]?.length || map.MOVE[pageName]?.length)
  }

  /*Function to get array of required variable objects*/
  getVariablesByNames(pageName: any, namesArray: any) {
    let tempCollection: any = [],
      collection = this.variableCollection[pageName];
    each(namesArray, (name) => {
      if (collection[name]) {
        tempCollection.push(collection[name]);
      }
    });
    return this.filterVariables(getClonedObject(tempCollection));
  }

  /**
   * filters the variable collection before pushing into the respective file
   * removes the properties not set by the user
   * removes properties internally used by wm-dev team (starting with '_')
   * removes dataBindings with empty value
   * @param variables list of variables to filter
   */
  filterVariables(variables: any) {
    forEach(variables, (variable) => {
      forEach(variable, (propertyValue, propertyName) => {
        if (propertyValue === "" || propertyValue === undefined || (stringStartsWith(propertyName, '_') && propertyName !== '_id') || propertyName === "$$hashKey") {
          delete variable[propertyName];
        }
      });
      if (variable.category === 'wm.CrudVariable') {
        this.cleanseCRUDBindings(variable.dataBinding, variable);
      } else {
        this.cleanseBindings(variable.dataBinding, variable);
      }
      if (variable.category === 'wm.NavigationVariable') {
        this.cleanseBindings(variable.dataSet);
      }
    });
    return variables;
  }

  /**
   * loops through the bindings in the provided object(not array as in other variable types), removes the ones with no value
   * @param bindings
   */
  cleanseCRUDBindings(bindings: any, variable: any) {
    forEach(bindings, (crudBindings, crudKey) => {
      this.cleanseBindings(crudBindings, variable);
      if (!crudBindings.length) {
        delete bindings[crudKey];
      }
    });
  }

  /**
   * loops through the binding objects in the provided array, removes the ones with no value
   * @param bindings
   */
  cleanseBindings(bindings: any, variable?: any) {
    let shouldCleanse,
      requiredKeys = VARIABLE_CONSTANTS.DATA_BINDING_FIELDS,
      redundantKeys;
    /* remove non-required keys from binding object */
    remove(bindings, (binding: any) => {
      shouldCleanse = (isUndefined(binding.value) || binding.value === '' || (isNull(binding.value) && variable && variable.category === 'wm.LiveVariable'));
      if (!shouldCleanse) {
        redundantKeys = difference(keys(binding), requiredKeys);
        forEach(redundantKeys, (key) => {
          binding[key] = undefined;
        });
      }
      return shouldCleanse;
    });
  }

  /*Function to call respective 'CRUD' service*/
  executeCrudOp(pageName: any) {
    return new Promise<void>((res, rej) => {
      if (this.isCrudEmpty(this.CRUDMAP, pageName)) {
        /*triggering success fn if map is empty*/
        return res();
      } else {
        let params: any = {
          projectId: this.projectService.getProjectId(),
          pageName: pageName
        },
          crudMapCopy: any = getClonedObject(this.CRUDMAP), //Making a cloned copy of crud map and using it in services
          opTypes = ['CREATE', 'UPDATE'];
        each(opTypes, (op) => {
          if (crudMapCopy[op][pageName]?.length) {
            params.data = cloneDeep(this.getVariablesByNames(pageName, crudMapCopy[op][pageName]));
            forEach(params.data, (item) => {
              if (item.category === 'wm.LiveVariable') {
                item.dataSet = [];
              }
            });
            // For Live var, make create call only if table name is present
            if (op === 'CREATE' && params.data[0].category === 'wm.LiveVariable' && pageName === 'App' && !params.data[0].tableName) {
              return res();
            }
            this.CRUDMAP[op][pageName] = [];//Emptying array in original map
            ((this as any)[op.toLowerCase()](params) as Promise<any>).then(() => {
              crudMapCopy[op][pageName] = [];//Emptying array in cloned map
              if (this.isCrudEmpty(crudMapCopy, pageName))
                res();
            }).catch((err: any) => {
              rej(err?.error);
            });
          }
        });
        /*Making a call to move variables*/
        if (crudMapCopy.MOVE[pageName]?.length) {
          params.toPage = pageName === VARIABLE_CONSTANTS.OWNER.APP ? this.pageService.activePageName : VARIABLE_CONSTANTS.OWNER.APP;
          this.CRUDMAP.MOVE[pageName] = [];//Emptying array in original map
          params.data = this.getVariablesByNames(params.toPage, crudMapCopy.MOVE[pageName]);
          (this.move(params) as Promise<any>).then(() => {
            crudMapCopy.MOVE[pageName] = [];//Emptying array in cloned map
            if (this.isCrudEmpty(crudMapCopy, pageName))
              res();
          }).catch((errMsg: any) => {
            rej(errMsg);
          });
        }
        /*Making a call to delete variables*/
        if (crudMapCopy.DELETE[pageName]?.length) {
          this.CRUDMAP.DELETE[pageName] = [];//Emptying array in original map
          params.deletedNames = crudMapCopy.DELETE[pageName].join(',');
          (this.delete(params) as Promise<any>).then(() => {
            crudMapCopy.DELETE[pageName] = [];//Emptying array in cloned map
            if (this.isCrudEmpty(crudMapCopy, pageName))
              res();
          }).catch((errMsg) => {
            rej(errMsg);
          });
        }
      }
    });
  }

  /**
   * @ngdoc method
   * @name $Variables#saveVariables
   * @methodOf wm.variables.$Variables
   * @description
   * Saves global variables in the file "app.variables.json"  and page level variables corresponding to active page separately, and show toaster message on Success/Failure
   * @param {string} activePageName Name of the active page.
   * @param {function} success success callback function.
   * @param {function} error error callback function.
   * @param {object} updateValues flag to update the variable values.
   *
   */
  saveVariables(activePageName: any, updateValues?: any) {
    return new Promise<void>((res, rej) => {
      /*activePage will not be there while in java service and db workspace*/
      let invokePageSave: boolean = false;
      if (updateValues) {
        this.updateVariableValues(activePageName);
        // save the page.min.json
        this.resourceMngr.removeUrlCache(activePageName);
        if (this.CRUDMAP.UPDATE['App'].length || this.CRUDMAP.UPDATE[activePageName]?.length) {
          invokePageSave = true;
        }
      }
      /* save app variables */
      this.executeCrudOp(VARIABLE_CONSTANTS.OWNER.APP).then((): any => {
        if (activePageName) {
          /* save page variables */
          this.executeCrudOp(activePageName).then((): any => {
            this.eventManager.emitUpdateVariableTree();
            this.resourceMngr.removeUrlCache(activePageName);
            if (includes(this.reloadRequired, 'App')) {
              this.reloadVariables().then(() => res());
            } else if (includes(this.reloadRequired, this.pageService.activePageName)) {
              this.initPageVariables(activePageName).then(() => res());
            } else {
              res();
            }
          }).then(() => {
            if(invokePageSave){
              runtimeEventManager.emit('loadDesign', activePageName);
            }
          }).catch((err) => {
            rej(err?.errors);
          });
        } else {
          if(invokePageSave){
            runtimeEventManager.emit('loadDesign', activePageName);
          }
          if (includes(this.reloadRequired, 'App')) {
            return this.reloadVariables();
          } else if (includes(this.reloadRequired, this.pageService.activePageName)) {
            return this.initPageVariables(activePageName);
          } else {
            res();
          }
        }
      }).catch((err) => {
        rej(err);
      });
    });
  }

  /**
   * @ngdoc method
   * @name $Variables#saveAppVariables
   * @methodOf wm.variables.$Variables
   * @description
   * Saves global variables in the file "app.variables.json" and show toaster message on Success/Failure
   * @param {object} updateValues flag to update the variable values.
   *
   */
  saveAppVariables(updateValues?: any) {
    return new Promise<void>((res, rej) => {
      if (updateValues) {
        this.updateVariableValues(updateValues);
      }
      /* save app variables */
      this.executeCrudOp(VARIABLE_CONSTANTS.OWNER.APP).then((): any => {
        if (includes(this.reloadRequired, 'App')) {
          this.reloadVariables();
        } else {
          res();
        }
      }).catch((err) => {
        rej(err);
      });
    });
  }

  /*function to reload the variables of current context*/
  reloadVariables() {
    return new Promise<void>((res, rej) => {
      let pageVariablesLoaded = false,
        appVariablesLoaded = false;

      this.reloadRequired.push(VARIABLE_CONSTANTS.OWNER.APP);
      this.initAppVariables().then(() => {
        appVariablesLoaded = true;
        /*Executing success if both app and current page variables are reloaded*/
        if (pageVariablesLoaded && appVariablesLoaded) {
          res();
        }
      }).catch(() => rej());
      if (this.pageService.activePageName) {
        this.reloadRequired.push(this.pageService.activePageName);
        this.initPageVariables(this.pageService.activePageName).then(() => {
          pageVariablesLoaded = true;
          /*Executing success if both app and current page variables are reloaded*/
          if (pageVariablesLoaded && appVariablesLoaded) {
            res();
          }
        }).catch(() => rej());
      } else {
        pageVariablesLoaded = true;
      }
    });
  }

  /*function to reload app variables*/
  reloadAppVariables() {
    this.reloadRequired.push(VARIABLE_CONSTANTS.OWNER.APP);
    this.initAppVariables();
  }

  /* function to initialize variables for passed page */
  initPageVariables(pageName: any, isUpdatePageVariables?: any) {
    return new Promise<void>((res, rej) => {
      let activePage = pageName;
      this.variableCollection = this.variableCollection || {};

      /* get page level variables */
      this.getPageVariables(activePage).then((pageVariables) => {

        /*if the file is empty, initialize the collection to empty object*/
        if (typeof pageVariables !== 'object') {
          pageVariables = {};
        }

        pageVariables = this.extendVariables(pageVariables);

        /* store the page variables collection */
        this.variableCollection[activePage] = pageVariables;
        this.updateVariableValues(activePage, !isUpdatePageVariables);

        /* emit an event to specify variables are loaded */
        // TODO
        // $rootScope.$emit('on-' + activePage + '-variables-ready', pageVariables);

        /* check for sanity of success call back and call it */
        res();
      }).catch((errMsg) => {
        /* initialize the app variables collection to empty */
        this.variableCollection[activePage] = {};
        rej(errMsg);
      });
    });
  }

  /*
  * returns true if variable is not of call type else false
  * @param variableCategory, category of the variable
  */
  checkCallVariableCategory(variableCategory: string) {
    return (variableCategory === 'wm.NavigationVariable' || variableCategory === 'wm.NotificationVariable' || variableCategory === 'wm.TimerVariable');
  }

  /**
   * For active variable, adds the binding objects to the properties list under respective Group and subgroup
   * these objects are utilized to display bindings in the UI
   * Set invalid flag on parameter object to highlight it in red
   */
  addBindingsToProperties(bindingTarget?: any) {
    bindingTarget = bindingTarget || 'dataBinding';
    let bindings = this.selectedVariable.variableObject[bindingTarget],
      isPropertyStatic = this.checkCallVariableCategory(this.selectedVariable.category) || this.selectedVariable.category === "wm.DeviceVariable",
      PROPERTY_PREFIX = 'wm_input_',
      targetParentGroup = "data",
      propertyType = "text",
      propertySubGroup,
      propertySubGroupObj: any,
      bindTarget,
      isHidden,
      showAutoUpdate = false,
      isprimary = false,
      isPaginationParam = (param: any) => {
        return (this.selectedVariable.variableObject.serviceType === VARIABLE_CONSTANTS.SERVICE_TYPE_DATA &&
          this.selectedVariable.category === "wm.ServiceVariable" &&
          VARIABLE_CONSTANTS.PAGINATION_PARAMS.indexOf(param) !== -1);
      };

    if (this.selectedVariable.category === "wm.LiveVariable") {
      propertySubGroup = this.selectedVariable.variableObject.operation === "read" ? "filterfields" : "inputfields";
      if (this.selectedVariable.variableObject.operation === "read" && this.selectedVariable.variableObject["filterExpressions"]) {
        var bindedProps = this.getAllFilterExpressions(this.selectedVariable.variableObject["filterExpressions"]);
        var columns = this.typeFactory.getFieldsForType(this.selectedVariable.variableObject.package, { 'filter': 'terminal', 'getFieldInfo': true });
        bindings = this.getAllPropertyBindings(columns, bindedProps);
      }
    } else if (this.selectedVariable.category === "wm.NavigationVariable" || this.selectedVariable.category === "wm.NotificationVariable") {
      if (bindingTarget === 'dataSet') {
        targetParentGroup = "data";
        propertySubGroup = "Inputs";
      } else {
        targetParentGroup = "properties";
        propertySubGroup = "Inputs";
      }
      if (this.createOnly) {
        isprimary = true;
      }
    } else if (this.selectedVariable.category === "wm.DeviceVariable") {
      targetParentGroup = "data";
      propertySubGroup = "Inputs";
    } else {
      targetParentGroup = "data";
      propertySubGroup = "inputfields";
    }

    //clear previously set binding properties
    this.clearOldBindingProps(bindingTarget);
    propertySubGroupObj = this.getSubGroupObjByName(targetParentGroup, propertySubGroup);
    if (this.selectedVariable.category === "wm.CrudVariable") {
      this.tabOrder.forEach((bindingKey: any) => {
        let binding: any = bindings[bindingKey];
        binding && binding.forEach((bindingObj: any) => {
          bindTarget = isPropertyStatic ? bindingObj.target : PROPERTY_PREFIX + bindingObj.target + bindingKey;
          isHidden = bindingObj.hide || isPaginationParam(bindingObj.target);
          showAutoUpdate = showAutoUpdate || !isHidden;
          propertySubGroupObj.properties.push(bindTarget);
          this.bindingsToClear.push(bindTarget);
          this.selectedVariable.propertyObj[bindTarget] = {
            "type": bindingObj.type || propertyType,
            "widgettype": bindingObj.widgettype || this.getWidgetType(bindingObj.type || propertyType),
            "format": bindingObj.format,
            "displayName": isPropertyStatic ? undefined : bindingObj.target,
            "subscript": bindingObj.subscript,
            "modelObj": bindingObj,
            "modelKey": "value",
            "dataBinding": true,
            "hide": isHidden,
            "useHelpTxt": bindingObj.useHelpTxt,
            "invalid": bindingObj.invalid,
            "isList": bindingObj.isList,
            "isprimary": isprimary,
            "bindingTarget": bindingTarget,
            "inputType": bindingKey
          };

          // for properties with list/typeahead type widgets, assign options
          if (bindingObj.options) {
            this.selectedVariable.propertyObj[bindTarget].options = bindingObj.options;
          }
          if (this.selectedVariable.propertyObj[bindTarget].dataBinding) {
            bindingObj.dataBinding = undefined;
          }

          /* check for auth-params for a REST service variable */
          if (stringStartsWith(bindingObj.target, 'wm_auth_')) {
            this.selectedVariable.propertyObj[bindTarget].displayName = bindingObj.target.replace('wm_auth_', '');
          }
        });
      });
    } else {
      bindings?.forEach((bindingObj: any) => {
        bindTarget = isPropertyStatic ? bindingObj.target : PROPERTY_PREFIX + bindingObj.target;
        isHidden = bindingObj.hide || isPaginationParam(bindingObj.target);
        showAutoUpdate = showAutoUpdate || !isHidden;
        propertySubGroupObj.properties.push(bindTarget);
        this.bindingsToClear.push(bindTarget);
        this.selectedVariable.propertyObj[bindTarget] = {
          "type": bindingObj.type || propertyType,
          "widgettype": bindingObj.widgettype || this.getWidgetType(bindingObj.type || propertyType),
          "format": bindingObj.format,
          "displayName": isPropertyStatic ? undefined : bindingObj.target,
          "subscript": bindingObj.subscript,
          "modelObj": bindingObj,
          "modelKey": "value",
          "dataBinding": true,
          "hide": isHidden,
          "useHelpTxt": bindingObj.useHelpTxt,
          "invalid": bindingObj.invalid,
          "isList": bindingObj.isList,
          "isprimary": isprimary,
          "bindingTarget": bindingTarget
        };

        // for properties with list/typeahead type widgets, assign options
        if (bindingObj.options) {
          this.selectedVariable.propertyObj[bindTarget].options = bindingObj.options;
        }
        if (this.selectedVariable.propertyObj[bindTarget].dataBinding) {
          bindingObj.dataBinding = undefined;
        }

        /* check for auth-params for a REST service variable */
        if (stringStartsWith(bindingObj.target, 'wm_auth_')) {
          this.selectedVariable.propertyObj[bindTarget].displayName = bindingObj.target.replace('wm_auth_', '');
        }
      });
    }



    // if no data-inputs under Data tab, hide the autoUpdate flag
    if (this.selectedVariable.category === "wm.ServiceVariable") {
      this.selectedVariable.propertyObj.autoUpdate.hide = !showAutoUpdate;
    }

    const selectedVarService = this.getSelectedVariableInstance();
    const propSubject: any = selectedVarService?.propertyGroupChangeSubject ? selectedVarService?.propertyGroupChangeSubject : selectedVarService[this.variableServiceMapper[selectedVarService.category]]?.propertyGroupChangeSubject;
    propSubject?.next(true);
  };

  /** creates a service variable based on the specified details */
  createServiceVariable(variableDetails: any, overWrite: any, createNewVariable: any) {
    /* call base service function to create the variable */
    let variableCategory = "wm.ServiceVariable",
      defaultName = variableDetails.name || initCaps(variableDetails.service) + initCaps(variableDetails.operation),
      createdVariable: any,
      variableName,
      variableOwner,
      bindMapCollection;

    /*If the default variable does not exist, create it.
     * Else, simply return the variable name.*/
    if (!this.isExists(defaultName) || overWrite || createNewVariable) {
      createdVariable = this.createVariable(variableCategory, { owner: variableDetails.owner || "Page" }, defaultName, overWrite);
      variableName = createdVariable.name;
      variableOwner = (createdVariable.owner === VARIABLE_CONSTANTS.OWNER.PAGE) ? this.pageService.activePageName : null;

      /*Set the "service" and "operation" properties of the service-variable.*/
      createdVariable.service = variableDetails.service;
      createdVariable.operation = variableDetails.operation;
      createdVariable.operationType = variableDetails.operationType;
      createdVariable.serviceType = variableDetails.serviceType;
      createdVariable.category = variableCategory;
      createdVariable.isDefault = true;
      createdVariable.controller = variableDetails.controller;
      createdVariable.operationId = variableDetails.operationId;
      createdVariable.type = variableDetails.returnType;
      createdVariable.dataBinding = variableDetails.dataBinding || [];

      forEach(['maxResults', 'startUpdate', 'autoUpdate', 'isList'], (property) => {
        if (isDefined(variableDetails[property])) {
          createdVariable[property] = variableDetails[property];
        }
      });

      /* insert sample param values if provided */
      bindMapCollection = createdVariable.dataBinding;
      forEach(variableDetails.sampleParamValues, (val, key) => {
        bindMapCollection.push({
          "target": key,
          "value": val,
          "type": "java.lang.String"
        });
      });
      /* Store the variable in proper category */
      this.store(variableOwner, variableName, createdVariable, true);
    } else {
      variableName = defaultName;
    }

    /*Return the name of the newly created variable.*/
    return variableName;
  }

  /**
  * @ngdoc function
  * @name wm.variables.$VariableService#create
  * @methodOf wm.variables.$VariableService
  * @function
  *
  * @description
  * Takes array of variable objects to be created
  *
  * @param {object} params object containing parameters for the request (else throws an error message)
  */
  create(params: any) {
    let action = 'addAppVariables',
      urlParams: any = {
        projectId: params.projectId
      };

    if (params.pageName !== 'App') {
      action = 'addPageVariables';
      urlParams.pageName = params.pageName;
    }
    return this.wmHttpService.execute({
      target: 'VariableService',
      action: action,
      pathParams: urlParams,
      data: params.data
    });
  }

  /**
   * @ngdoc function
   * @name wm.variables.$VariableService#create
   * @methodOf wm.variables.$VariableService
   * @function
   *
   * @description
   * Takes array of variable objects to be created
   *
   * @param {object} params object containing parameters for the request (else throws an error message)
   */
  update(params: any) {
    let action = 'updateAppVariables',
      urlParams: any = {
        projectId: params.projectId
      };

    if (params.pageName !== 'App') {
      action = 'updatePageVariables';
      urlParams.pageName = params.pageName;
    }
    return this.wmHttpService.execute({
      target: 'VariableService',
      action: action,
      pathParams: urlParams,
      data: params.data
    });
  }

  /**
   * @ngdoc function
   * @name wm.variables.$VariableService#move
   * @methodOf wm.variables.$VariableService
   * @function
   *
   * @description
   * Takes array of variable objects to be moved
   *
   * @param {object} params object containing parameters for the request (else throws an error message)
   */
  move(params: any) {
    let action = 'moveAppVariables',
      urlParams: any = {
        projectId: params.projectId
      };

    if (params.pageName !== 'App') {
      action = 'movePageVariables';
      urlParams.pageName = params.pageName;
    } else {
      urlParams.toPage = params.toPage
    }

    return this.wmHttpService.execute({
      target: 'VariableService',
      action: action,
      pathParams: urlParams,
      data: params.data
    });
  }

  /**
   * @ngdoc function
   * @name wm.variables.$VariableService#delete
   * @methodOf wm.variables.$VariableService
   * @function
   *
   * @description
   * Takes array of variable names to be deleted
   *
   * @param {object} params object containing parameters for the request (else throws an error message)
   */
  delete(params: any) {
    let action = 'deleteAppVariables',
      urlParams: any = {
        projectId: params.projectId,
        deletedNames: params.deletedNames
      };

    if (params.pageName !== 'App') {
      action = 'deletePageVariables';
      urlParams.pageName = params.pageName;
    }
    return this.wmHttpService.execute({
      target: 'VariableService',
      action: action,
      pathParams: urlParams
    });
  }

  /**
   * @ngdoc function
   * @name wm.variables.$VariableService#getServiceOpInfo
   * @methodOf wm.variables.$VariableService
   * @function
   *
   * @description
   * Get service operation info in run
   *
   * @param {object} params object containing parameters for the request (else throws an error message)
   */
  getServiceOpInfo(params: any) {
    return this.wmHttpService.execute({
      target: 'VariableService',
      action: 'getServiceOpInfo',
      pathParams: params
    });
  }

  /**
   * @ngdoc function
   * @name wm.variables.$VariableService#getPrefabServiceOpInfo
   * @methodOf wm.variables.$VariableService
   * @function
   *
   * @description
   * Get service operation info in run
   * @param {object} params object containing parameters for the request (else throws an error message)
   */
  getPrefabServiceOpInfo(params: any) {
    return this.wmHttpService.execute({
      target: 'VariableService',
      action: 'getPrefabServiceOpInfo',
      pathParams: params
    });
  }

  /** creates a live variable based on the specified details */
  createLiveVariable(variableDetails: any, fetchData: boolean) {
    /* call base service function to create the variable */
    let variableCategory = "wm.LiveVariable",
      defaultName,
      createdVariable: any,
      variableName,
      variableOwner;

    defaultName = variableDetails.name || initCaps(variableDetails.service) + initCaps(variableDetails.table) + "Data";

    /*If the default variable does not exist, create it.
    * Else, simply return the variable name.*/
    if (!this.isExists(defaultName)) {
      createdVariable = this.createVariable(variableCategory, { owner: variableDetails.owner || "Page", "isList": true }, defaultName);
      variableName = createdVariable.name;
      variableOwner = (createdVariable.owner === VARIABLE_CONSTANTS.OWNER.PAGE) ? this.pageService.activePageName : null;

      /*Set the "liveSource" and "type" properties of the live-variable.*/
      createdVariable.liveSource = variableDetails.service;
      createdVariable.type = variableDetails.table;
      createdVariable.package = variableDetails.package;
      createdVariable.category = variableCategory;
      createdVariable.isDefault = true;
      forEach(['maxResults', 'startUpdate', 'autoUpdate', 'bindCount'], (property) => {
        if (isDefined(variableDetails[property])) {
          createdVariable[property] = variableDetails[property];
        }
      });

      /*adding a property to identify the database-type for the created live-variable*/
      createdVariable.dbSystem = variableDetails.dbSystem;

      /* Store the variable in proper category */
      this.store(variableOwner, variableName, createdVariable, true, fetchData);
    } else {
      variableName = defaultName;
    }

    /*Return the name of the newly created variable.*/
    return variableName;
  }


  /*function to store a variable to the collection*/
  store(owner: any, name: any, variableObj: any, isUpdate?: boolean, fetchData?: boolean) {
    /* sanity checking */
    if (!variableObj) {
      return;
    }
    let varCollectionObj = this.variableCollection,
        isPrefabTemplate = this.projectService.isPrefabType();
    owner = isPrefabTemplate ? (owner || 'Main') : (owner || VARIABLE_CONSTANTS.OWNER.APP);
    // scope = pageScopeMap[owner]; // TO DO - needed?

    /* Condition: If type does not exist yet, then create one */
    if (!varCollectionObj.hasOwnProperty(owner) || !varCollectionObj[owner]) {
      varCollectionObj[owner] = {};
    }

    /* Assign a unique id to the newly created variable */
    if(!variableObj['_id'] ){
      variableObj['_id'] = "wm-" + name + "-" + variableObj.category + "-" + (new Date().getTime());
    }

    /* Store variable based on type */
    varCollectionObj[owner][name] = cloneDeep(variableObj);
    varCollectionObj[owner][name].name = name;

    this.studioCopy[owner][name] = varCollectionObj[owner][name];

    if (variableObj.category === 'wm.LiveVariable') {
      variableObj._isNew = true;
      variableObj["filterExpressions"] = {};
    }

    // TO DO

    /* if app level variable make it available in the active page scope */
    if (owner === VARIABLE_CONSTANTS.OWNER.APP) {
      if (!this.variableInstanceCollection[owner][name] && this.variableInstanceCollection[this.pageService.activePageName] && this.variableInstanceCollection[this.pageService.activePageName][name]) {
        let varInstance = this.variableInstanceCollection[this.pageService.activePageName][name];
        this.variableInstanceCollection[owner][name] = varInstance;
        delete this.variableInstanceCollection[this.pageService.activePageName][name];
      }
      if (this.pageService.activePageName && this.pageScopeMap[this.pageService.activePageName]) {
        Object.defineProperty(this.pageScopeMap[this.pageService.activePageName].Variables, name, {
          configurable: true,
          get: function () {
            return varCollectionObj[owner][name];
          }
        });
      }
    }
    if (!includes(this.CRUDMAP.CREATE[owner], name)) {
      if (!this.CRUDMAP.CREATE[owner]) {
        this.CRUDMAP.CREATE[owner] = [];
      }
      this.CRUDMAP.CREATE[owner].push(name);/*Storing  created variable name in map*/
    }
    if (isUpdate) {
      Object.assign(varCollectionObj[owner][name], variableObj );
      this.updateVariableData(varCollectionObj[owner][name], name, owner, undefined, { skipFetchData: !fetchData })
    }
    //TODO: need to add wm.navigationVariable into the variable instance Collection
    if (this.variableInstanceCollection[owner][name]) {
      Object.assign(this.variableInstanceCollection[owner][name], varCollectionObj[owner][name]); // extending the instance object with the collection object to add package and table info
      if (this.variableCollection[owner][name] && this.variableInstanceCollection[owner][name].invoke) {
        this.variableCollection[owner][name].invoke = this.variableInstanceCollection[owner][name].invoke;
      }
    }

  }

  /*function to update a variable object
  * variableName name of the variable, old name in case of name change
  * newProperties varible object with updated properties
  * isUpdate flag to decide if variable data set has to be update*/
  updateVariable = (variableName: any, newProperties: any, isUpdate?: any) => {
    let newName = newProperties.name,
      updated = false,
      isPrefabTemplate = this.projectService.isPrefabType(),
      pageName: any = newProperties.owner === 'App' ? 'App' : (isPrefabTemplate ? (this.pageService.activePageName || this.MAIN_PAGE) : this.pageService.activePageName),
      oldOwner = pageName === 'App' ? this.pageService.activePageName : 'App',
      scope = this.pageScopeMap[pageName];
    /* Condition: Checking for existence of the variable name, updating variable object*/
    if (find(this.variableCollection[pageName], { '_id': newProperties._id })) {
      this.variableCollection[pageName][newName] = newProperties;
      updated = true;
      if (!includes(this.CRUDMAP.UPDATE[pageName], newName) && !includes(this.CRUDMAP.CREATE[pageName], newName)) {
        if (!this.CRUDMAP.UPDATE[pageName])
          this.CRUDMAP.UPDATE[pageName] = [];
        this.CRUDMAP.UPDATE[pageName].push(newName);
      }
      if (variableName !== newName) {
        delete this.variableCollection[pageName][variableName];
        this.reloadRequired.push(pageName);
      }
      if (this.variableInstanceCollection[pageName][variableName] && newName !== variableName) {
        this.variableInstanceCollection[pageName][newName] = this.variableInstanceCollection[pageName][variableName];
        Object.assign(this.variableInstanceCollection[pageName][newName], this.variableCollection[pageName][newName]);
        delete this.variableInstanceCollection[pageName][variableName];
      }
    } else if (find(this.variableCollection[oldOwner], { '_id': newProperties._id })) {
      /*In case of owner change checking for variable existence in old scope and deleting*/
      this.variableCollection[pageName][newName] = newProperties;
      /*Removing those variable from old scope*/
      delete this.variableCollection[oldOwner][variableName];
      if (!includes(this.CRUDMAP.MOVE[oldOwner], newName)) {
        if (!this.CRUDMAP.MOVE[oldOwner])
          this.CRUDMAP.MOVE[oldOwner] = [];
        this.CRUDMAP.MOVE[oldOwner].push(newName);
      }
      updated = true;
    }
    if (isUpdate) {
      this.call('getData', newName, { scope: scope, skipFetchData: true });
    }
    return updated;
  }

  /*function to return a variable object respective to a name*/
  getVariableByName = (variableName: string, scope?: any) => {
    let variables = this.variableCollection;
    let variableType: string | undefined;

    /* if scope provided, check if variable should be taken from partial -> happens when view parent is partial. Similar for prefab also */
    if (scope) {
      variableType = scope.viewParent?.partialName;
      if (!variableType && scope.viewParent?.prefabName) {
        variableType = this.getVariableConstants().PREFAB_PREFIX + scope.viewParent?.prefabName;
      }
    }

    if (!variables) {
      return;
    }

    /* return the variable against active page or app (In studio mode, this is the writable variable obejct */
    // if variable is inside a partial, then return the variable against the partial
    return variableType ? variables[variableType][variableName] : (variables[this.pageService.activePageName] && variables[this.pageService.activePageName][variableName]) || (variables[VARIABLE_CONSTANTS.OWNER.APP] && variables[VARIABLE_CONSTANTS.OWNER.APP][variableName]) || null;
  }

  /* function exposed to call method available with a variable */
  call = (method: any, name: any, options: any, success?: any, error?: any) => {
    /* check params sanity */
    options = options || {};

    /* if variable name or method not given, return error */
    if (!name || !method) {
      triggerFn(error);
      return;
    }

    let variable = this.getVariableByName(name, options.scope),
      type = variable.category;

    /*invoke the getData method of the specified variable category*/
    return this.baseVariablePropertyFactory.invoke(method, type, variable, options, (data: any, propertiesMap: any, pagingOptions: any) => {
      triggerFn(success, data, propertiesMap, pagingOptions);
    }, error);
  }

  /*function to filter the variable collection based on the object map provided*/
  filterByVariableKeys = (variableParams: any, searchAllContexts?: any) => {
    let variables = this.variableCollection,
      currentVariable,
      variableOwner,
      variableNames,
      varParamsArray = keys(variableParams),
      index,
      varParamCounter,
      currentVarParam,
      filteredVariables: any = [],
      isPrefabTemplate = this.projectService.isPrefabType(),
      defaultContextArray = isPrefabTemplate ? [this.MAIN_PAGE, this.pageService.activePageName] : [VARIABLE_CONSTANTS.OWNER.APP, this.pageService.activePageName];

    if (variableParams.owner) {
      variableOwner = isPrefabTemplate ? (this.pageService.activePageName || this.MAIN_PAGE) : (variableParams.owner === VARIABLE_CONSTANTS.OWNER.APP) ? VARIABLE_CONSTANTS.OWNER.APP : this.pageService.activePageName;
    }

    /*function to find the variables which match the all the keys in the object map provided*/
    function findMatchingVariables(contextVariables: any, context: any) {
      variableNames = keys(contextVariables);

      /*iterating over the variables of a specific context, either app or page*/
      for (index = 0; index < variableNames.length; index++) {
        currentVariable = variables[context][variableNames[index]];

        /*iterating over the filter keys provided and validating if the
        * current variable's properties match the filter keys provided*/
        for (varParamCounter = 0; varParamCounter < varParamsArray.length; varParamCounter++) {
          currentVarParam = varParamsArray[varParamCounter];

          /*checking if the properties match, if so pushing the param key to the
          * temp array*/
          if (currentVariable[currentVarParam] !== variableParams[currentVarParam]) {
            break;
          }
        }
        /*if all properties have been matched and are validated to true, then push
         * the current variable to the filtered variables array*/
        if (varParamCounter === varParamsArray.length) {
          if (filteredVariables.indexOf(currentVariable) === -1) {
            currentVariable.name = variableNames[index];
            filteredVariables.push(currentVariable);
          }
        }
      }
    }

    /*if searchAllContexts is false, use the variable owner if provided, else use the
    * default contexts - app and active-page to filter the variables.*/
    if (!searchAllContexts) {
      /*if the variable owner is available, then provide the context to filter variables*/
      if (variableOwner) {
        findMatchingVariables(variables[variableOwner], variableOwner);
      } else {
        /*if no variable owner and searchAllContexts is false, restrict the contexts
        * to default variable contexts*/
        defaultContextArray.forEach((context) => {
          findMatchingVariables(variables[context], context);
        });
      }
    } else {
      /*if searchAllContext is true, then use each context in the
       * variable collection for filtering the collection*/
      Object.keys(variables).forEach((context: any) => {
        /*only filtering the context for app and pages, ignoring scope-id contexts*/
        if (isNaN(context)) {
          findMatchingVariables(variables[context], context);
        }
      });
    }
    return filteredVariables;
  }

  /**
   * @ngdoc method
   * @name $Variables#getMappedServiceQueryParams
   * @methodOf wm.variables.$Variables
   * @description
   * returns array of query param names for variable other then page,size,sort
   * @params {params} params of the variable
   */
  getMappedServiceQueryParams(params: any) {
    return map(reject(params, (param) => {
      return includes(VARIABLE_CONSTANTS.PAGINATION_PARAMS, param.name);
    }), (param) => {
      return param.name;
    });
  }

  getInstanceCollection() {
    return this.variableInstanceCollection;
  }

  getVariableInstance(varExpr: string, partial: any): any {
    let condition = varExpr.startsWith('bind:') ? 'bind:Variables.' : 'Variables.';
    let variableName: any = varExpr?.replace(condition, '').split('.')[0];
    let varInstance: any;
    let variableInstanceCollection = this.variableInstanceCollection;
    if (variableInstanceCollection['App'] && variableInstanceCollection['App'][variableName]) {
      varInstance = variableInstanceCollection['App'][variableName];
    } else if (variableInstanceCollection[this.pageService.activePageName]?.[variableName]) {
      varInstance = variableInstanceCollection[this.pageService.activePageName][variableName];
    } else if (partial && variableInstanceCollection[partial] && variableInstanceCollection[partial][variableName]) {
      varInstance = variableInstanceCollection[partial][variableName];
    }
    return varInstance;
  }

  invokeDataset(varInstance: any) {
    const url = this.projectService.getAppDeployedUrl();
    if (url) {
      return varInstance.invoke();
    }
    return new Promise((resolve, reject)=>{
      this.projectService.getAppRunURL(false).then(()=>{
        varInstance.invoke().then(resolve).catch(reject);
      });
    });
  }

  getVariableFromNameSpace(prefab: string = ''): any {
    const varCollection = this.getInstanceCollection();
    const projectDetails = this.projectService.getDetails();
    let varNamespace = this.pageService.activePageName;
    if (prefab) {
      varNamespace = projectDetails.type === 'PREFAB' ? prefab : this.getVariableConstants().PREFAB_PREFIX + prefab;
    }
    return varCollection[varNamespace];
  }
}
